// App.js
import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react';
import {
  Box, Typography, TextField, MenuItem, Button,
  Card, CardContent, Chip, Stack,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Divider, Tooltip,
  LinearProgress, Select,Checkbox,  InputLabel, FormControl,
  Container,  Paper, Grid, ButtonGroup, Switch, FormControlLabel,   Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  FormGroup,
  CardActionArea, Avatar

} from '@mui/material';
// ✅ add these at the top with your other imports
import { Routes, Route, useParams, useNavigate, useLocation } from 'react-router-dom';
import {    getDoc } from 'firebase/firestore'; // you already import some of these
import { onSnapshot, startAfter, collectionGroup } from 'firebase/firestore';
import {
      limit as qLimit
} from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid'; // if not already present: npm i uuid
import PlumbingIcon from '@mui/icons-material/Plumbing';
import ConstructionIcon from '@mui/icons-material/Construction';        // Home Improvement
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService'; // Remodel
import AcUnitIcon from '@mui/icons-material/AcUnit';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import RoofingIcon from '@mui/icons-material/Roofing';
import HandymanIcon from '@mui/icons-material/Handyman';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import YardIcon from '@mui/icons-material/Yard';
import PestControlIcon from '@mui/icons-material/PestControl';
import MovingIcon from '@mui/icons-material/Moving';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import AppsIcon from '@mui/icons-material/Apps'; // for “All”
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'; // “General”
import CloseIcon from '@mui/icons-material/Close';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import SortIcon from '@mui/icons-material/Sort';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';   // AI sparkle icon
import PsychologyIcon from '@mui/icons-material/Psychology';     // optional alt AI icon
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import logo from './leadfeed.png';
import logo2 from './ypg.png';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';


import LocalFloristIcon from '@mui/icons-material/LocalFlorist';
import ForestIcon from '@mui/icons-material/Forest';

import BuildIcon from '@mui/icons-material/Build';
import PlaceIcon from '@mui/icons-material/Place';





import { db } from './firebase';
import {
  getFirestore, serverTimestamp, setDoc, doc, getDocs, collection, query,
  orderBy, limit, deleteDoc, addDoc,
  where
} from 'firebase/firestore';
import DetailsModal from './DetailsModal';
import { LeadCard } from './LeadCard';


// === Paging / helpers (place near top) ===
const PAGE_SIZE = 200;

const toMs = (v) => {
  if (!v && v !== 0) return 0;
  const n = Number(v);
  if (!Number.isNaN(n) && n > 0) return n;
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
};

// Stable keys for grid items & saved set
const displayKey = (p) =>
  p?.id || p?.postId || p?.permalink || JSON.stringify([p.author, p.text]).slice(0, 200);
const leadKey = displayKey;


// Base URLs
const DEV_BASE  = 'http://localhost:4001'; 
const PROD_BASE = 'https://api-vasejd2hkq-uc.a.run.app'; // your Cloud Function URL
const LEADS_COLLECTION = 'newscrapes';
// Paths
const DEV_PATH  = '/scrape';   // local backend
const PROD_PATH = '/scrapes';  // cloud function
// Cloud Functions base URL (prod) with .env override for dev/staging
// Live Cloud Function base (prod)
const API_BASE =
  process.env.REACT_APP_API_URL ||
  'https://api-vasejd2hkq-uc.a.run.app';

// Local Node server base JUST for /scrape while testing


// Minimal fetch helper for the live API
async function apiFetch(path, { method = 'GET', body, headers } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...(headers || {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const text = await res.text();
  let json; try { json = JSON.parse(text); } catch { json = { raw: text }; }
  if (!res.ok) throw new Error(`[${method} ${path}] ${json?.error || text || `HTTP ${res.status}`}`);
  return json;
}

const SCRAPE_ROOT = 'newscrapes';


/* ===================== FIREBASE ===================== */
// === NEW: collections for logs ===
const COLL_SCRAPES = 'newscrapesVA';     // one doc per scrape run
const COLL_LOGS = 'lead_logs';
const COLL = 'scrape1';
const COLL_SAVED = 'savedLeads';
const COLL_UP = 'review_up';
const COLL_DOWN = 'review_down';
/* ==================================================== */

/* ===================== RAPIDAPI (Skip Trace) ===================== */
const RAPID_HOST = 'skip-tracing-working-api.p.rapidapi.com';
const RAPID_KEY  = '9a9f567ca7mshde6da4d9e730111p1d71efjsn5f96bb14baee';

// Make a short id
const rid = () => Math.random().toString(36).slice(2,10);

// Create a log at START


// List logs (newest first)
async function loadScrapeLogs(limitTo = 200) {
  if (!db) return [];
  const q1 = query(collection(db, COLL_SCRAPES), orderBy('startedAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
  return rows;
}
const startOfTodayLocalMs = () => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};
// Leads by scrape
async function loadLeadsByScrape(scrapeId, limitTo = 4000) {
  if (!db || !scrapeId) return [];
  const q1 = query(collection(db, COLL), where('scrapeId', '==', scrapeId), orderBy('createdAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

async function logEvent(post, type, payload = {}) {
  if (!db) return;
  const key = leadKey(post);
  const parent = collection(db, COLL_LOGS, key, 'events');
  await addDoc(parent, {
    type,                 // 'captured' | 'call' | 'review_up' | 'review_down' | 'note'
    at: serverTimestamp(),
    payload,              // { sourceTs?, note?, meta? }
  });
}
// Walk top-level /newscrapes/* and log each batch's /leads
async function debugLogNewscrapeLeads() {
  const db = getFirestore();
  console.log('🔍 Scanning Firestore /newscrapes …');

  const batchesSnap = await getDocs(collection(db, 'newscrapes'));
  console.log(`📦 newscrapes: found ${batchesSnap.size} batch doc(s)`);

  let total = 0;

  for (const batchDoc of batchesSnap.docs) {
    const batchId = batchDoc.id;
    const leadsColRef = collection(db, 'newscrapesVA', batchId, 'leads');
    const leadsSnap = await getDocs(leadsColRef);

    console.log(`— batch ${batchId} → ${leadsSnap.size} lead doc(s)`);

    // Show a few example rows from this batch
    leadsSnap.docs.slice(0, 5).forEach((d, i) => {
      const x = d.data() || {};
      const posted =
        x.postedAt ??
        x.datePosted ??
        x.timestamp ??
        (x.meta && x.meta.capturedAt) ??
        null;

      const platform = x.platform ?? (x.meta && x.meta.source) ?? '';
      const previewText = (x.text || '').replace(/\s+/g, ' ').slice(0, 140);

      console.log(
        `   [${i}] id=${d.id} author=${x.author || '(none)'} ` +
        `postedAt=${posted} platform=${platform} text="${previewText}"`
      );
    });

    total += leadsSnap.size;
  }

  console.log(`✅ Total leads across all batches: ${total}`);
}

// Cross-check: pull ALL leads from any batch via collectionGroup
// (No orderBy so it won't require an index.)
async function debugLogAllLeadsCollectionGroup() {
  const db = getFirestore();
  const cgSnap = await getDocs(collectionGroup(db, 'leads'));
  console.log(`🌐 collectionGroup('leads') returned ${cgSnap.size} doc(s) total`);

  cgSnap.docs.slice(0, 10).forEach((d, i) => {
    const x = d.data() || {};
    const path = d.ref.path; // e.g. newscrapes/{batchId}/leads/{leadId}
    const posted =
      x.postedAt ??
      x.datePosted ??
      x.timestamp ??
      (x.meta && x.meta.capturedAt) ??
      null;

    console.log(
      `   [${i}] ${path} — author=${x.author || '(none)'} postedAt=${posted} ` +
      `platform=${x.platform ?? (x.meta && x.meta.source) ?? ''}`
    );
  });
}
const inferServiceType = (post) => {
  const ai = post?.aiSummary?.serviceType || post?.ai?.serviceType || post?.serviceType || '';
  if (ai) return String(ai);

  const idHas = (rx) => Array.isArray(post?.tags) && post.tags.some(t => rx.test(String(t?.id || '')));
  if (idHas(/^TS/)) return 'Tree Service';
  if (idHas(/^LC/)) return 'Lawn Care';
  if (idHas(/^RT/)) return 'Roofing';

  const txt = `${post?.text || ''}`.toLowerCase();
  if (/\broof|shingle|leak\b/.test(txt)) return 'Roofing';
  if (/\btrim|tree|stump\b/.test(txt)) return 'Tree Service';
  if (/\blawn|mow|yard|mulch|sod\b/.test(txt)) return 'Lawn Care';
  if (/\bhvac|ac|air\s*conditioning|furnace|heat\b/.test(txt)) return 'HVAC';
  if (/\bplumb|leak|clog|drain|pipe\b/.test(txt)) return 'Plumbing';
  return 'General';
};

const serviceIcon = (label) => {
  const s = String(label || '').toLowerCase();
  if (s.includes('tree')) return <ForestIcon fontSize="small" />;
  if (s.includes('lawn') || s.includes('landscap')) return <LocalFloristIcon fontSize="small" />;
  if (s.includes('roof')) return <RoofingIcon fontSize="small" />;
  if (s.includes('hvac') || s.includes('ac')) return <AcUnitIcon fontSize="small" />;
  if (s.includes('plumb')) return <PlumbingIcon fontSize="small" />;
  return <BuildIcon fontSize="small" />;
};

const serviceColors = (label) => {
  const s = String(label || '').toLowerCase();
  if (s.includes('tree')) return { bg: '#dcfce7', fg: '#065f46' };
  if (s.includes('lawn') || s.includes('landscap')) return { bg: '#d1fae5', fg: '#065f46' };
  if (s.includes('roof')) return { bg: '#fee2e2', fg: '#991b1b' };
  if (s.includes('hvac') || s.includes('ac')) return { bg: '#dbeafe', fg: '#1e3a8a' };
  if (s.includes('plumb')) return { bg: '#e0e7ff', fg: '#3730a3' };
  return { bg: '#f3f4f6', fg: '#111827' };
};

const neighborhoodOf = (post) =>
  post?.neighborhood ||
  post?.meta?.neighborhood ||
  post?.location?.neighborhood ||
  null;

const profileImageOf = (post) =>
  post?.authorPhoto ||
  post?.profileImage ||
  post?.meta?.authorPhotoUrl ||
  post?.meta?.profileImage ||
  null;


async function fetchTimeline(post, max = 200) {
  if (!db) return [];
  const key = leadKey(post);
  const q1 = query(collection(db, COLL_LOGS, key, 'events'), orderBy('at', 'desc'), limit(max));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push({ id: d.id, ...d.data() }));
  return rows;
}

// Ensure we have a "captured" event (use post.capturedAt as the source time hint)
async function ensureCapturedEvent(post) {
  const events = await fetchTimeline(post, 20);
  const has = events.some(e => e.type === 'captured');
  if (!has) {
    await logEvent(post, 'captured', { sourceTs: post.capturedAt || null });
    return fetchTimeline(post); // re-fetch so UI shows it
  }
  return events;
}
async function skipTraceSearch({ mode = 'byname', name = '', street = '', citystatezip = '', page = 1 }) {
  const base = `https://${RAPID_HOST}/search`;
  let url = '';
  const p = new URLSearchParams({ page: String(page) });

  if (mode === 'bynameaddress') {
    if (name) p.set('name', name);
    if (citystatezip) p.set('citystatezip', citystatezip);
    url = `${base}/bynameaddress?${p.toString()}`;
  } else if (mode === 'byaddress') {
    if (street) p.set('street', street);
    if (citystatezip) p.set('citystatezip', citystatezip);
    url = `${base}/byaddress?${p.toString()}`;
  } else {
    if (name) p.set('name', name);
    url = `${base}/byname?${p.toString()}`;
  }

  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'x-rapidapi-host': RAPID_HOST,
      'x-rapidapi-key': RAPID_KEY,
    },
  });

  const text = await res.text();
  if (!res.ok) throw new Error(`SkipTrace HTTP ${res.status}: ${text.slice(0,180)}`);
  let data;
  try { data = JSON.parse(text); } catch { throw new Error('SkipTrace response not JSON'); }
  return data;
}

// Try to find the lead in-memory by _key, displayKey(), or postId

// --- helpers (keep in same file) ---
// ADD NEAR OTHER REFS

// REPLACE your existing "auto-generate summary on open/selected" effect with this guarded one:

function isTreeLead(post) {
  const t = String(post?.meta?.type || post?.type || '').toLowerCase();
  const c = String(post?.classification || '').toLowerCase();
  const tags = Array.isArray(post?.meta?.tags)
    ? post.meta.tags.map(x => String(x?.id || '').toLowerCase())
    : Array.isArray(post?.tags)
      ? post.tags.map(x => String(x?.id || '').toLowerCase())
      : [];

  if (t.includes('tree')) return true;
  if (c === 'tree' || c.includes('tree')) return true;
  if (tags.some(id => id.includes('tree'))) return true;
  return false;
}

async function fetchTreeCallScript(post, aiSummaryText) {
  const payload = {
    post: {
      author: post?.author || '',
      text: cleanFbNoise(post?.text || ''),
      lang: post?.lang || 'en',
      translatedEn: post?.translatedEn || '',
      permalink: post?.permalink || '',
      profileUrl: post?.profileUrl || '',
      timestamp: post?.timestamp ?? null,
    },
    meta: {
      classification: post?.classification || '',
      type: post?.type || '',
      market: post?.market || post?.searchMarket || '',
      searchPhrase: post?.searchPhrase || '',
      platform: post?.platform || 'facebook',
    },
    aiSummaryText: String(aiSummaryText || ''),
    // lightweight instruction so backend knows what to do
    instruction: `
Generate a short, friendly PHONE CALL SCRIPT for a sales rep at a tree service company.
Make it sound human and kind, not robotic. Use the info in the post and the AI summary.
Goals:
1) Confirm they're seeking help (removal/trim/stump/emergency)
2) Clarify location & timing (today/this week)
3) Qualify: tree count, height/size, hazards (near roof, power lines), access
4) Offer next step: free estimate/site visit; schedule a time
5) Handle light objection (“just price shopping”) with empathy
6) Close with clear next step

Format:
- Opener (one or two sentences)
- 3–5 short question bullets
- Offer & next step (one or two sentences)
- Soft close (one sentence)

Keep it under ~160 words. Use the name “we” for the company. No placeholders like {{name}}.
If it looks like a contractor ad, return a 1-line polite note saying it's likely a vendor post.
`.trim(),
  };

  // Primary endpoint (name it how you prefer)
  try {
    const data = await apiFetch('/ai/call-script', { method: 'POST', body: payload });
    return { text: data?.text || '' };
  } catch (e1) {
    // Fallback (keep consistent with your pattern)
    const data = await apiFetch('/ai/script', { method: 'POST', body: payload });
    return { text: data?.text || '' };
  }
}
async function skipTraceDetailsById(peo_id) {
  const url = `https://${RAPID_HOST}/search/detailsbyID?peo_id=${encodeURIComponent(peo_id)}`;
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      'x-rapidapi-host': RAPID_HOST,
      'x-rapidapi-key': RAPID_KEY,
    },
  });
  const text = await res.text();
  if (!res.ok) throw new Error(`SkipTrace details HTTP ${res.status}: ${text.slice(0,180)}`);
  let data;
  try { data = JSON.parse(text); } catch { throw new Error('SkipTrace details response not JSON'); }
  return data;
}
/* ==================================================== */

// ---------- helpers ----------
const canonUrl = (u) => {
  try {
    if (!u) return '';
    if (u.startsWith('/')) u = 'https://www.facebook.com' + u;
    const url = new URL(u);
    url.hostname = url.hostname.replace(/^m\./i, 'www.');
    url.hash = '';
    const keep = new Set(['id', 'story_fbid']);
    [...url.searchParams.keys()].forEach(k => { if (!keep.has(k)) url.searchParams.delete(k); });
    let path = url.pathname.replace(/\/+$/, '');
    if (path === '') path = '/';
    return `${url.protocol}//${url.hostname}${path}${url.search ? '?' + url.searchParams.toString() : ''}`;
  } catch {
    return u || '';
  }
};
const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();
const safeLC = (s) => norm(s).toLowerCase();
// Remove the "Facebook Facebook Facebook ..." prefix that some posts carry
function cleanFbNoise(text = "") {
  return String(text).replace(/^(Facebook\s*){2,}/i, "").trim();
}
const hash = (s) => { let h = 2166136261 >>> 0; for (let i=0;i<s.length;i++){h^=s.charCodeAt(i);h=(h*16777619)>>>0;} return h.toString(36); };
const jaccard = (a, b) => {
  const A = new Set(safeLC(a).split(/\W+/).filter(Boolean));
  const B = new Set(safeLC(b).split(/\W+/).filter(Boolean));
  if (!A.size || !B.size) return 0;
  let inter = 0; for (const w of A) if (B.has(w)) inter++;
  return inter / (A.size + B.size - inter);
};
function safeId(str = '') {
  try {
    return btoa(unescape(encodeURIComponent(str)))
      .replace(/\//g, '_')
      .replace(/\+/g, '-'); // make it Firestore-safe
  } catch {
    return hash(str); // fallback: just hash if it breaks
  }
}
const makeKey = (p) => {
  const permalink = canonUrl(p.permalink || '');
  const profile = canonUrl(p.profileUrl || '');
if (permalink) return `u:${safeId(permalink)}`;
  if (profile && p.timestamp) return `t:${profile}::${p.timestamp}`;
  const textSig = hash(safeLC((p.text || '').slice(0, 400)));
  return `x:${textSig}`;
};

// naive parsers for Skip Trace defaults
const stripEmojiEtc = (s='') => s.replace(/[\u{1F300}-\u{1FAFF}\u{1F1E6}-\u{1F1FF}]/gu, '').trim();
const guessNameFromAuthor = (author='') => {
  const a = stripEmojiEtc(author).split(' · ')[0].split(' | ')[0];
  return a.replace(/\((admin|moderator|agent|realtor)\)/ig, '').trim();
};

// ---- SkipTrace detail helpers (robust to weird key names) ----
const val = (obj, ...keys) => {
  for (const k of keys) {
    if (obj && obj[k] != null && obj[k] !== '') return obj[k];
  }
  return '';
};
const asArr = (x) => (Array.isArray(x) ? x : x ? [x] : []);
const phoneMask = (p='') => String(p).replace(/[^\d]/g,'').replace(/^(\d{3})(\d{3})(\d{4}).*/, '($1) $2-$3');

const getSummary = (d) => ({
  name: val(d, 'Full Name', 'full_name', 'Name', 'name'),
  age:  val(d, 'Age', 'age', 'Age Range', 'age_range'),
  dob:  val(d, 'DOB', 'dob', 'Date Of Birth', 'date_of_birth'),
  aka:  asArr(val(d, 'Aliases', 'AKA', 'Also Known As', 'aliases')),
});

const getPhones = (d) =>
  asArr(val(d, 'Phones', 'phones', 'Phone Numbers', 'phone_numbers'))
    .map(p => (typeof p === 'string' ? { number: p } : p));

const getEmails = (d) =>
  asArr(val(d, 'Emails', 'emails', 'Email Addresses', 'email_addresses'))
    .map(e => (typeof e === 'string' ? { email: e } : e));

const getAddresses = (d) =>
  asArr(val(d, 'Addresses', 'addresses', 'Address History', 'address_history')).map(a => ({
    line: val(a, 'Address', 'address', 'Street', 'street', 'Line1', 'line1'),
    city: val(a, 'City', 'city'),
    state: val(a, 'State', 'state'),
    zip: val(a, 'ZIP', 'Zip', 'zip'),
    from: val(a, 'From', 'from', 'Start', 'start'),
    to:   val(a, 'To', 'to', 'End', 'end'),
  }));

const getRelatives = (d) =>
  asArr(val(d, 'Relatives', 'relatives', 'Associates', 'associates')).map(r => ({
    name: val(r, 'Name', 'name', 'Full Name', 'full_name'),
    relation: val(r, 'Relation', 'relation', 'Relationship', 'relationship'),
  }));

const extractCityStateZip = (text='') => {
  const m1 = text.match(/\b([A-Za-z .'-]+,\s*[A-Z]{2}\s*\d{5})\b/);
  if (m1) return m1[1].replace(/\s+/g,' ').trim();
  const m2 = text.match(/\b([A-Za-z .'-]+,\s*[A-Z]{2})\b/);
  if (m2) return m2[1].replace(/\s+/g,' ').trim();
  return '';
};

// de-dupe
const dedupePosts = (input) => {
  if (!Array.isArray(input)) return [];
  const prepared = input.map(p => ({
    ...p,
    permalink: canonUrl(p.permalink || ''),
    profileUrl: canonUrl(p.profileUrl || ''),
    author: norm(p.author || ''),
    text: norm(p.text || ''),
  }));
  const firstPass = [];
  const seen = new Set();
  for (const p of prepared) {
    const k = makeKey(p);
    if (seen.has(k)) continue;
    seen.add(k);
    firstPass.push({ ...p, __key: k });
  }
  const byAuthor = new Map();
  for (const p of firstPass) {
    const a = p.author || '—';
    if (!byAuthor.has(a)) byAuthor.set(a, []);
    byAuthor.get(a).push(p);
  }
  const final = [];
  for (const [, arr] of byAuthor) {
    const kept = [];
    for (const p of arr) {
      let dup = false;
      for (const q of kept) {
        const sim = jaccard(p.text, q.text);
        if (sim >= 0.9 || safeLC(p.text).slice(0, 180) === safeLC(q.text).slice(0, 180)) {
          const preferP = (p.permalink && !q.permalink) || (p.text || '').length > (q.text || '').length;
          if (preferP) kept.splice(kept.indexOf(q), 1, p);
          dup = true;
          break;
        }
      }
      if (!dup) kept.push(p);
    }
    final.push(...kept);
  }
  final.sort((a,b)=> (!!b.permalink-!!a.permalink));
  return final;
};
// Treat as "Lawncare" if the Type says so OR any tag id starts with LC
const isLawncarePost = (p) => {
  const t = String(p?.type || '').toLowerCase();
  if (t === 'lawncare' || t === 'landscaping') return true;
  return Array.isArray(p?.tags) && p.tags.some(tag => /^LC/.test(tag?.id || ''));
};
const isRoofingPost = (p) => {
  const t = String(p?.type || '').toLowerCase();
  if (t === 'roofing') return true;
  return Array.isArray(p?.tags) && p.tags.some(tag => /^RT/.test(tag?.id || ''));
};

const isTreeServicePost = (p) => {
  const t = String(p?.type || '').toLowerCase();
  if (t === 'tree service' || t === 'tree-service' || t === 'treeservice') return true;
  return Array.isArray(p?.tags) && p.tags.some(tag => /^TS/.test(tag?.id || ''));
};
// ---------- Firestore helpers ----------
async function saveOneToFirestore(post) {
  if (!db) { console.warn('[Firestore] not initialized'); return; }
  const id = makeKey(post);
  const docRef = doc(db, COLL, id);
  await setDoc(docRef, {
    ...post,
    permalink: canonUrl(post.permalink || ''),
    profileUrl: canonUrl(post.profileUrl || ''),
    _key: id,
    createdAt: serverTimestamp(),
    scrapeId: post.scrapeId || null,       // 👈 NEW
  }, { merge: true });
}


async function deleteOneFromFirestore(post) {
  if (!db) throw new Error('[Firestore] not initialized');
  const id = makeKey(post);

  // Delete the doc from main & aux buckets
  await Promise.allSettled([
    deleteDoc(doc(db, COLL, id)),
    deleteDoc(doc(db, COLL_SAVED, id)),
    deleteDoc(doc(db, COLL_UP, id)),
    deleteDoc(doc(db, COLL_DOWN, id)),
  ]);

  // Optional: delete timeline logs subcollection
  try {
    const parent = collection(db, COLL_LOGS, id, 'events');
    const snap = await getDocs(parent);
    await Promise.allSettled(snap.docs.map(d => deleteDoc(d.ref)));
    // delete the parent doc (container) after clearing subcollection
    await deleteDoc(doc(db, COLL_LOGS, id));
  } catch (e) {
    // logs are optional — ignore if they don't exist
  }
}



// Pull “all” scrapes so we filter client-side
const MAX_PULL = 10000;
async function loadFromFirestore(limitTo = MAX_PULL) {
  if (!db) { throw new Error('[Firestore] not initialized'); }
  const collRef = collection(db, COLL);
  const q1 = query(collRef, orderBy('createdAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

// Saved Leads helpers
async function saveLead(post) {
  if (!db) return;
  const id = makeKey(post);
  await setDoc(doc(db, COLL_SAVED, id), {
    ...post,
    _key: id,
    savedAt: serverTimestamp(),
  }, { merge: true });
}
async function removeSavedLead(post) {
  if (!db) return;
  const id = makeKey(post);
  await deleteDoc(doc(db, COLL_SAVED, id));
}
async function loadSavedLeads(limitTo = 4000) {
  if (!db) return [];
  const q1 = query(collection(db, COLL_SAVED), orderBy('savedAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}
// Review helpers (thumbs up / down)
async function saveReview(post, verdict, reason) {
  if (!db) return;
  const id = makeKey(post);
  const coll = verdict === 'up' ? COLL_UP : COLL_DOWN;

  const reviewObj = {
    verdict,
    reason,
    at: serverTimestamp(),
  };

  // Save in thumbs collection
  await setDoc(doc(db, coll, id), { ...post, _key: id, review: reviewObj }, { merge: true });

  // ✅ Also save back to main scrape collection
  await setDoc(doc(db, COLL, id), { review: reviewObj }, { merge: true });
}
async function loadReviewBucket(verdict, limitTo = 2000) {
  if (!db) return [];
  const coll = verdict === 'up' ? COLL_UP : COLL_DOWN;
  const q1 = query(collection(db, coll), orderBy('review.at', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

// ---------- Tag helpers we’ll add to each scrape ----------
const SRC_FACEBOOK = { id: 'SRC_FB', label: 'facebook', color: '#DBEAFE' }; // pale blue
const typeTag = (t) => ({ id: `TYPE_${t.toUpperCase()}`, label: t.toLowerCase(), color: '#E9D5FF' }); // violet
const marketTag = (m) => ({ id: `MKT_${safeLC(m)}`, label: safeLC(m), color: '#FDE68A' }); // amber
const capturedTag = (iso) => ({ id: `CAP_${iso}`, label: `captured ${iso}`, color: '#D1FAE5' }); // green

// ---------- UI ----------
const chipStyles = {
  owner: { bg: '#d1fae5', fg: '#065f46' },
  prospector: { bg: '#fee2e2', fg: '#7f1d1d' },
  homeowner: { bg: '#dcfce7', fg: '#065f46' },
  uncertain: { bg: '#fde68a', fg: '#7c2d12' },
};
// Convert newscrapes/{batch}/leads/* → grid "post" shape the UI expects
function normalizeLeadDoc(d) {
  const x = d.data() || {};
  const batchId = d.ref.parent?.parent?.id || null;

  // posted time: prefer explicit postedAt; fall back to meta.capturedAt
  const postedAt =
    (typeof x.postedAt === 'number' && x.postedAt > 0 && x.postedAt) ||
    (typeof x.datePosted === 'number' && x.datePosted > 0 && x.datePosted) ||
    (typeof x.timestamp === 'number' && x.timestamp > 0 && x.timestamp) ||
    (typeof x?.meta?.capturedAt === 'number' && x.meta.capturedAt) ||
    0;

  return {
    id: d.id,
    author: x.author || 'Unknown',
    text: x.text || '',
    // what your filters look for
    platform: x.platform || x?.meta?.source || 'nextdoor',
    type: 'nextdoor',
    subtype: x.subtype || null,

    // time fields used by getPostedAtMs()
    postedAt,
    capturedAt: x?.meta?.capturedAt || null,
    datePosted: x.datePosted || null,
    datePostedLabel: x.datePostedLabel || null,
    timeLabel: x.timeLabel || null,

    // misc used by chips/filters
    market: x.market || x?.meta?.market || null,
    tags: Array.isArray(x.tags) ? x.tags : [],
    lang: x.lang || x.language || null,

    // provenance
    source: 'newscrapesVA',
    sourceScrapeId: batchId,
    scrapeId: batchId,

    // handy meta
    meta: x.meta || {},
    permalink: x.permalink || x?.meta?.permalink || null,
  };
}
// CSV helpers
function tagsToIdList(tags=[]) { return tags.map(t=>t.id).join(';'); }
function tagsToLabelList(tags=[]) { return tags.map(t=>t.label).join(';'); }
function csvEscape(v) {
  const s = (v===undefined || v===null) ? '' : String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}
function flattenPhones(list = [], details = []) {
  // Accept strings, {number}, {raw}, or full objects from "All Phone Details"
  const out = [];

  const pushNum = (raw, meta = {}) => {
    if (!raw) return;
    const digits = String(raw).replace(/\D/g, '');
    if (digits.length < 7) return;                            // ignore non-numbers
    const pretty =
      digits.length === 10
        ? `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`
        : digits.length === 11 && digits.startsWith('1')
        ? `+1 ${digits.slice(1,4)}-${digits.slice(4,7)}-${digits.slice(7)}`
        : raw;
    const parts = [pretty];
    if (meta.type) parts.push(meta.type);
    if (meta.provider) parts.push(meta.provider);
    if (meta.last || meta.last_reported) parts.push(meta.last || meta.last_reported);
    out.push(parts.join(' • '));
  };

  // Simple array: strings or { number } or { raw }
  for (const p of list) {
    if (!p) continue;
    if (typeof p === 'string') pushNum(p);
    else if (p.number) pushNum(p.number, p);
    else if (p.raw)    pushNum(p.raw, p);
    else if (p.phone)  pushNum(p.phone, p);
  }

  // Detailed list (from "All Phone Details")
  for (const d of details) {
    const raw =
      d?.phone_number || d?.number || d?.Phone || d?.phone || d?.raw;
    const meta = {
      type: d?.phone_type || d?.type || d?.Type,
      provider: d?.provider,
      last: d?.last_reported || d?.last || d?.LastReported,
    };
    pushNum(raw, meta);
  }

  // De-dupe
  return Array.from(new Set(out));
}

function flattenEmails(list = []) {
  const out = [];
  for (const e of list) {
    if (!e) continue;
    if (typeof e === 'string') out.push(e);
    else if (e.email) out.push(e.email);
    else if (e.Email) out.push(e.Email);
  }
  return Array.from(new Set(out));
}

function stringifyAddress(a = {}) {
  const line = a.line || a.Address || a.Street || a.line1 || '';
  const city = a.city || a.City || '';
  const state = a.state || a.State || '';
  const zip = a.zip || a.ZIP || a.Zip || a.postalCode || '';
  const span = a.span || a.timespan || a.date_range || '';

  const left = [line, [city, state].filter(Boolean).join(', '), zip].filter(Boolean).join(' • ');
  return span ? `${left} (${span})` : left;
}
// 🟢 NEW: CSV for Brad Leads with skip-trace fields
function makeBradCSV(rows = []) {
  const header = [
     'Title','Description','Profile URL','Post URL','Tags','Review Verdict','Review Reason',
    'AI Verdict','AI Summary',
     'SkipTrace Name','SkipTrace Age','SkipTrace DOB',
     'Phones','Emails','Addresses','Relatives'
   ];
  const lines = [header.join(',')];

  for (const r of rows) {
    const title = r.author || '';
    const description = cleanFbNoise(r.text) || '';
    const profile = r.profileUrl || '';
    const post = r.permalink || '';

    const tagParts = [];
    if (r.platform) tagParts.push(r.platform);
    if (r.market)   tagParts.push(r.market);
    if (r.type)     tagParts.push(r.type);
    if (r.capturedAt) tagParts.push(`captured ${r.capturedAt}`);
    (r.tags || []).forEach(t => t?.label && tagParts.push(t.label));
    const tags = tagParts.join('; ');

    const verdict = r.review?.verdict || '';
    const reason  = r.review?.reason  || '';
   const aiVerdict = r.aiSummary?.verdict || '';
   const aiText    = r.aiSummary?.text    || '';
    const st = r.skipTrace || {};
    const name = st?.summary?.name || '';
    const age  = st?.summary?.age  || '';
    const dob  = st?.summary?.dob  || '';

    // ✅ Phones: look in BOTH simple array and detailed array
    const stPhonesSimple  = Array.isArray(st.phones) ? st.phones : [];
    const stPhonesDetails =
      Array.isArray(st.phoneDetails) ? st.phoneDetails
      : Array.isArray(st['All Phone Details']) ? st['All Phone Details']
      : Array.isArray(st.details?.['All Phone Details']) ? st.details['All Phone Details']
      : [];
    const phones = flattenPhones(stPhonesSimple, stPhonesDetails).join('; ');

    const emails = flattenEmails(st?.emails || []).join('; ');
    const addresses = (st?.addresses || []).map(a => stringifyAddress(a)).join(' | ');
    const relatives = (st?.relatives || []).map(x =>
      [x.name, x.relation].filter(Boolean).join(' (') + (x.relation ? ')' : '')
    ).join(' | ');

   const row = [
      title, description, profile, post, tags, verdict, reason,
     aiVerdict, aiText,
      name, age, dob, phones, emails, addresses, relatives
    ].map(csvEscape);

    lines.push(row.join(','));
  }
  return lines.join('\n');
}
function makeCSV(rows) {
   const header = [
    'Title','Description','Profile URL','Post URL','Tags','Review Verdict','Review Reason',
   'AI Verdict','AI Summary'
  ];

  const lines = [header.join(',')];

  for (const r of rows) {
    const title = r.author || '';
    const description = cleanFbNoise(r.text) || '';
    const profile = r.profileUrl || '';
    const post = r.permalink || '';

    // Gather all traits/tags
    const traitParts = [];
    if (r.platform) traitParts.push(r.platform);
    if (r.market) traitParts.push(r.market);
    if (r.type) traitParts.push(r.type);
    if (r.capturedAt) traitParts.push(`captured ${r.capturedAt}`);
    if (Array.isArray(r.tags)) {
      for (const t of r.tags) {
        if (t?.label) traitParts.push(t.label);
      }
    }
    const tags = traitParts.join('; ');

    // ✅ Pull review verdict + reason if present
  const verdict   = r.review?.verdict || '';
  const reason    = r.review?.reason  || '';
  const aiVerdict = r.aiSummary?.verdict || '';
  const aiText    = r.aiSummary?.text || '';
  const row = [title, description, profile, post, tags, verdict, reason, aiVerdict, aiText].map(csvEscape);    lines.push(row.join(','));
  }

  return lines.join('\n');
}
function downloadBlob(filename, text) {
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}



export default function PropertyGuys() {
  const { leadId } = useParams();        // 🟩 MOVE THIS TO THE VERY TOP
  const navigate = useNavigate();        // 🟩 also define this early
  const [keyword, setKeyword] = useState('');
  const [state, setState] = useState('Ohio');
    const [legendOpen, setLegendOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [onlyScrapes, setOnlyScrapes] = useState(true);
const [ndSubtypeFilter, setNdSubtypeFilter] = useState('all'); // 'all' | 'general' | 'plumbing' | ...
  const [target, setTarget] = useState(25);
  const [viewingScrapeId, setViewingScrapeId] = useState(null);
  const [acOpen, setAcOpen] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
const inFlightRef = useRef(false);
  const [smartOpen, setSmartOpen] = React.useState(false);
const [smartLoading, setSmartLoading] = React.useState(false);
const [smartError, setSmartError] = React.useState("");
const [smartComments, setSmartComments] = React.useState([]);
  const [showRecentOnly, setShowRecentOnly] = useState(false);
const [showPast5DaysOnly, setShowPast5DaysOnly] = useState(false);
  // ===== FIX: hooks/state must live inside the component =====
const lastSummaryKeyRef = React.useRef(null);


const sentinelRef = React.useRef(null); // for infinite scroll

const [showPast2WeeksOnly, setShowPast2WeeksOnly] = useState(false);
  const [aiSummary, setAiSummary] = useState(null);        // { verdict: 'good'|'medium'|'bad', text: '...' }
const [aiSummaryLoading, setAiSummaryLoading] = useState(false);
const [aiSummaryError, setAiSummaryError] = useState('');
  const [selected, setSelectedState] = useState(null); // shadow for types
  const [scrapeView, setScrapeView] = useState(
  () => localStorage.getItem('scrapeView') || 'wholesale'
);
const setSelected = setSelectedState;
const [activeTab, setActiveTab] = useState('leads'); // 'leads' | 'logs'
const [scrapeLogs, setScrapeLogs] = useState([]);
const [logsLoading, setLogsLoading] = useState(false);
const [logsError, setLogsError] = useState('');
const [activeDateWindow, setActiveDateWindow] = React.useState(null);
const [pageCursor, setPageCursor]   = React.useState(null); // last doc snapshot
const [hasMore, setHasMore]         = React.useState(true);
const [loadingMore, setLoadingMore] = React.useState(false);
  const [campaignType, setCampaignType] = useState('Wholesale'); // <-- NEW: chosen type added to each scrape
const [nationwide, setNationwide] = useState(false);
  const [loading, setLoading] = useState(false);
  const [posts, setPosts] = useState([]);
  const [error, setError] = useState('');
  const [source, setSource] = useState('saved'); // 'live' | 'firestore' | 'saved' | 'thumbs_up' | 'thumbs_down'
const [deleting, setDeleting] = useState(false);
const [aiLoading, setAiLoading] = useState(false);
const [aiError, setAiError] = useState('');
// Date range filter state
const [dateMode, setDateMode] = React.useState('all'); // 'all', 'single', or 'range'
const [dateSingle, setDateSingle] = React.useState(null);
const [dateRange, setDateRange] = React.useState([null, null]);
const [dateLoading, setDateLoading] = React.useState(false);
const [dateError, setDateError] = React.useState('');
const [aiSuggestions, setAiSuggestions] = useState([]); // [{term, score, thumbsUp, reason}]
const aiSuggestTimer = useRef(null);
// Scheduled scrapes (live)
const [scheduled, setScheduled] = useState([]);
const [scheduledLoading, setScheduledLoading] = useState(false);
const [scheduledError, setScheduledError] = useState('');
const scheduledUnsubRef = useRef(null);
const expectedMsRef = useRef(0);
  // Filters
  const [filterType, setFilterType] = useState('All');
  const [filterMarket, setFilterMarket] = useState('All');
  const [minOwner, setMinOwner] = useState('');
  const [maxProspector, setMaxProspector] = useState('');
  const [sortBy, setSortBy] = useState('recent'); // 'recent' | 'relevant'
// Timeline
const [timeline, setTimeline] = useState([]);
const [timelineLoading, setTimelineLoading] = useState(false);
const [noteText, setNoteText] = useState('');
  // progress UI
  const [kwFocused, setKwFocused] = useState(false);
const kwInputRef = useRef(null);

  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState('Preparing…');
  const [eta, setEta] = useState('');
  // modal + meta state
// modal + current scrape
const [scrapeModalOpen, setScrapeModalOpen] = useState(false);
const [currentScrapeId, setCurrentScrapeId] = useState(null);
const [scrapeMeta, setScrapeMeta] = useState(null);

// keep Firestore unsubs in refs (no TDZ, safe across re-renders)
const unsubMetaRef  = useRef(null);
const unsubLeadsRef = useRef(null);
// store unsubscribers at module scope (you already declared these up top)

  const [devMode, setDevMode] = useState(() => localStorage.getItem('devMode') === '1');
  // at top of your component
const [callScript, setCallScript] = React.useState(null);
const [callScriptLoading, setCallScriptLoading] = React.useState(false);
const [callScriptError, setCallScriptError] = React.useState('');
const [leadSearch, setLeadSearch] = React.useState('');
const [sendingIdx, setSendingIdx] = React.useState(null);
const [chosenSuggestion, setChosenSuggestion] = React.useState(null);
const [sending, setSending] = React.useState(false);
const [sendError, setSendError] = React.useState(null);

const SEEN_STORAGE_KEY = 'seenLeadsV1';
const stableLeadKey = (p) =>
  p?.postId || p?._id || p?.id || p?.permalink || p?.postUrl || '';

// In parent
const selKey = useMemo(() => stableLeadKey(selected), [selected]);

// Initial load


useEffect(() => {
  handleLoadSaved({ initial: true });
  // optional: show the Leads tab by default
  setActiveTab?.('leads');
}, []);
useEffect(() => {
  
const db = getFirestore()
  const checkNewscrapes = async () => {
    console.log('🔍 Checking Firestore "newscrapes" collection...');
    try {
      const snap = await getDocs(collection(db, 'newscrapes'));
      console.log(`📦 newscrapes: found ${snap.size} docs`);

      const data = snap.docs.map(d => ({
        id: d.id,
        ...d.data(),
      }));
      console.log('🧩 Example doc:', data[0] || 'none');
      console.log('🧮 All docs:', data);

      // Optional: quick sanity check for text field
      data.forEach((doc, i) => {
        console.log(`→ [${i}] author=${doc.author} text=${(doc.text || '').slice(0, 100)}`);
      });
    } catch (err) {
      console.error('❌ Firestore query error:', err);
    }
  };

  checkNewscrapes();
}, []);

useEffect(() => {
  // Pick one for now:
  debugLogNewscrapeLeads();
  // debugLogAllLeadsCollectionGroup();
}, []);
useEffect(() => {
  if (!sentinelRef.current) return;
  const io = new IntersectionObserver(
    (entries) => {
      const hit = entries[0]?.isIntersecting;
      if (hit && hasMore && !loadingMore) {
        handleLoadSaved({ initial: false });
      }
    },
    { rootMargin: '600px 0px 600px 0px' }
  );

  io.observe(sentinelRef.current);
  return () => io.disconnect();
}, [hasMore, loadingMore, handleLoadSaved]);
useEffect(() => {
  if (!detailsOpen || !selKey) return;
  let cancelled = false;

  setAiSummaryLoading(true);
  fetchAiLeadSummaryOnce(selected)
    .then((sum) => { if (!cancelled) setAiSummary(sum); })
    .catch((e)  => { if (!cancelled) setAiSummaryError(e.message || String(e)); })
    .finally(() => { if (!cancelled) setAiSummaryLoading(false); });

  return () => { cancelled = true; };
}, [detailsOpen, selKey]);   // 👈 only re-run when the key (lead identity) changes
const [seenKeys, setSeenKeys] = useState(() => {
  try {
    const arr = JSON.parse(localStorage.getItem(SEEN_STORAGE_KEY) || '[]');
    return new Set(Array.isArray(arr) ? arr : []);
  } catch { return new Set(); }
});

// 🔹 Find a lead locally by any of its possible IDs
function findLeadLocallyByAnyId(posts, leadId) {
  if (!Array.isArray(posts)) return null;
  return posts.find(
    (p) =>
      p.postId === leadId ||
      p.id === leadId ||
      p._id === leadId ||
      p.scrapeId === leadId
  );
}
// In parent

useEffect(() => {
  if (!detailsOpen || !selKey) return;
  let cancelled = false;

  setAiSummaryLoading(true);
  fetchAiLeadSummaryOnce(selected)
    .then((sum) => { if (!cancelled) setAiSummary(sum); })
    .catch((e)  => { if (!cancelled) setAiSummaryError(e.message || String(e)); })
    .finally(() => { if (!cancelled) setAiSummaryLoading(false); });

  return () => { cancelled = true; };
}, [detailsOpen, selKey]);   // 👈 only re-run when the key (lead identity) changes
React.useEffect(() => {
  const key = selected ? (selected.id || selected.permalink || selected.profileUrl) : null;
  if (!detailsOpen || !selected || !key) return;

  // Prevent duplicate fetches for the same lead while modal is open
  if (lastSummaryKeyRef.current === key) return;
  lastSummaryKeyRef.current = key;

  // Your existing trigger here:
  // e.g., fetchAiSummary(selected) or handleGenerateScript('summary') etc.
  // make sure it ultimately sets setAiSummary(...)
  handleGenerateScript?.('summary');
}, [detailsOpen, selected, handleGenerateScript]);

// When the modal fully closes, allow a fresh fetch next time (optional but nice):
React.useEffect(() => {
  if (!detailsOpen) lastSummaryKeyRef.current = null;
}, [detailsOpen]);

// 🔹 Fetch a lead directly from Firestore if it wasn’t loaded yet


useEffect(() => {
  try { localStorage.setItem(SEEN_STORAGE_KEY, JSON.stringify([...seenKeys])); } catch {}
}, [seenKeys]);

async function markSeen(post) {
  const key = makeKey(post);
  setSeenKeys(prev => {
    if (prev.has(key)) return prev;
    const next = new Set(prev);
    next.add(key);
    return next;
  });
  // optional: persist a timeline event
  try { await logEvent(post, 'viewed', {}); } catch {}
}


async function sendChosen() {
  if (!chosenSuggestion) return;
  setSendError(null);
  setSending(true);
  try {
    const postUrl = selected?.postUrl || selected?.permalink;
    if (!postUrl) throw new Error("Missing post URL");
 const r = await fetch('http://localhost:4001/nd/send-comment', 
  {      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: postUrl, text: chosenSuggestion })
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.error || 'Failed to send');
    // optional toast here
  } catch (e) {
    setSendError(e.message || String(e));
  } finally {
    setSending(false);
  }
}


async function handleSendSmartComment(suggestionText) {
  setSendError(null);
  setSendingIdx(-1); // show global spinner if you want
  try {
    const postUrl = selected?.postUrl || selected?.permalink;
    if (!postUrl) throw new Error("Missing post URL");

    const r = await fetch("/nd/send-comment", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ url: postUrl, text: suggestionText }),
    });
    const j = await r.json();
    if (!r.ok) throw new Error(j.error || "Failed to send");

    // optional: toast success
    // enqueueSnackbar("Sent! Browser left open.", { variant: "success" });
  } catch (e) {
    setSendError(e.message || String(e));
  } finally {
    setSendingIdx(null);
  }
}
function norm(s) {
  return String(s || '').toLowerCase();
}
function textForSearch(post) {
  // author + cleaned text in one haystack
  return `${norm(post.author)} ${norm(cleanFbNoise(post.text))}`;
}

// reset script state whenever lead changes or modal re-opens

useEffect(() => {
  localStorage.setItem('scrapeView', scrapeView);
}, [scrapeView]);
const canGenerateScript = isTreeLead(selected) && !!aiSummary?.text;

async function handleOpenSmartComments() {
  if (!selected?.text) return;
  setSmartOpen(true);
  setSmartLoading(true);
  setSmartError("");
  setSmartComments([]);

  try {
    const resp = await fetch("http://localhost:4001/ai/smart-comments", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ post: { text: selected.text, author: selected.author } })
    });
    const data = await resp.json();
    if (!resp.ok) throw new Error(data?.error || "Failed to generate");
    setSmartComments(Array.isArray(data.suggestions) ? data.suggestions : []);
  } catch (e) {
    setSmartError(e.message || "Failed to generate");
  } finally {
    setSmartLoading(false);
  }
}

function closeSmart() {
  setSmartOpen(false);
}
async function handleGenerateScript() {
  if (!canGenerateScript) return;
  setCallScript(null);
  setCallScriptError('');
  setCallScriptLoading(true);
  try {
    const result = await fetchTreeCallScript(selected, aiSummary?.text || '');
    setCallScript(result.text || '');
  } catch (err) {
    setCallScriptError(err?.message || 'Could not generate script');
  } finally {
    setCallScriptLoading(false);
  }
}
function normalizeNewLeadDoc(d) {
  const x = d.data() || {};

  const postedAt =
    (typeof x.postedAt === 'number' && x.postedAt > 0 && x.postedAt) ||
    (typeof x.datePosted === 'number' && x.datePosted > 0 && x.datePosted) ||
    (typeof x.timestamp === 'number' && x.timestamp > 0 && x.timestamp) ||
    (typeof x?.meta?.capturedAt === 'number' && x.meta.capturedAt) ||
    0;

  return {
    id: d.id,
    author: x.author || 'Unknown',
    text: x.text || '',
    platform: x.platform || x?.meta?.source || 'nextdoor',
    type: 'nextdoor',
    subtype: x.subtype || null,

    postedAt,
    capturedAt: x?.meta?.capturedAt || null,
    datePosted: x.datePosted || null,
    datePostedLabel: x.datePostedLabel || null,
    timeLabel: x.timeLabel || null,

    market: x.market || x?.meta?.market || null,
    tags: Array.isArray(x.tags) ? x.tags : [],
    lang: x.lang || x.language || null,

    source: 'newleads',
    sourceScrapeId: x.scrapeId || null,
    scrapeId: x.scrapeId || null,

    meta: x.meta || {},
    permalink: x.permalink || x?.meta?.permalink || null,
  };
}
function copyToClipboard(text) {
  try {
    navigator.clipboard.writeText(text || '');
  } catch {}
}

// 🔼 put these at module scope (top of your component file)
const toTs = (v) => {
  if (!v && v !== 0) return 0;
  const n = Number(v);
  if (!Number.isNaN(n) && n > 0) return n;
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
};
const getCapturedMs = (r) => {
  if (typeof r?.meta?.capturedAt === 'number') return r.meta.capturedAt;
  if (typeof r?.capturedAt === 'number') return r.capturedAt;
  return toTs(r?.timestamp);
};


const statusEmoji = (s) => (s === 'success' ? '✅' : s === 'error' ? '❌' : '⏳');
useEffect(() => {
  if (activeTab === 'logs') refreshLogs();
}, [activeTab]); // put near other effects
// Use localhost:4001 in dev mode; fall back to your existing API_BASE in prod
// put near other helpers
const fetchOnlyNewLeads = async () => {
  const db = getFirestore();
  console.log('🔎 Querying root collection "newleads" only…');

  // If you want most-recent first and to cap results, uncomment:
  // const q = query(collection(db, 'newleads'), orderBy('postedAt', 'desc'), limit(200));
  // const snap = await getDocs(q);

  const snap = await getDocs(collection(db, 'newleads'));
  console.log(`📦 newleads count: ${snap.size}`);

  const mapped = snap.docs.map(normalizeNewLeadDoc);
  const usable = mapped.filter(p => (p.postedAt || p.capturedAt));
  console.log(`🧾 Mapped ${mapped.length} → usable ${usable.length}`);
  usable.slice(0, 10).forEach((p, i) => {
    console.log(
      `   [${i}] id=${p.id} author=${p.author} postedAt=${p.postedAt} platform=${p.platform} text="${(p.text||'').replace(/\s+/g,' ').slice(0,120)}"`
    );
  });

  setPosts(usable);
  setHasMore(false);   // we’re not paginating here
};

// 🟢 NEW: preload Brad set
useEffect(() => {
  (async () => {
    try {
      const brad = await loadBradLeads(1000);
      setBradKeys(new Set(brad.map(p => makeKey(p))));
    } catch {}
  })();
}, []);

useEffect(() => {
  if (activeTab !== 'leads') return;

  // 👇 If we're looking at a specific scrape, do NOT autoload "Saved" / default.
  if (viewingScrapeId) return;
 if (source !== 'saved') return;
 if (onlyScrapes) return;

  setPosts([]);
  setPageCursor(null);
  setHasMore(true);
  handleLoadSaved({ initial: true });
}, [activeTab, viewingScrapeId, source]);

useEffect(() => {
  return () => detachScrapeListeners();
}, []);

const toDate = (v) =>
  v?.toDate ? v.toDate() :
  (typeof v === 'number' ? new Date(v) :
  (typeof v === 'string' ? new Date(v) : null));
  const progressTimer = useRef(null);
  const startTs = useRef(0);
  const reqIdRef = useRef(0); // ✅ ADD THIS LINE
  // hearts
  const [savedKeys, setSavedKeys] = useState(new Set());
const [bradKeys, setBradKeys] = useState(new Set());
  // Treat these as automated runs
const isAutomated = (row) =>
  !!(
    row?.automated ||                    // explicit flag from payload/backend
    row?.source === 'scheduler' ||       // backend set a source
    /scheduler|cron|auto/i.test(row?.env || '') || // env hint
    row?.createdBy === 'scheduler'       // alternate field name
  );

function attachScheduledListener() {
  if (scheduledUnsubRef.current) scheduledUnsubRef.current(); // cleanup

  try {
    setScheduledLoading(true);
    setScheduledError('');

    // Common field names we’ll normalize:
    //  - status: 'scheduled' | 'queued' | 'pending' | 'running' | ...
    //  - scheduledFor / runAt / startsAt (Timestamp/number/ISO)
    //  - type, keyword, market, target, env
    const colRef = collection(db, 'newscrapes');

    // Prefer a server-side filter if you have "status" and "scheduledFor"
    // (You may need to accept Firestore’s index prompt once.)
    let q1 = query(
      colRef,
      where('status', 'in', ['scheduled', 'queued', 'pending']),
      orderBy('scheduledFor', 'asc'),
      qLimit(50)
    );

    // If your schema doesn’t have "scheduledFor" but uses "runAt"/"startsAt",
    // you can change orderBy('scheduledFor','asc') to whichever you have.

    scheduledUnsubRef.current = onSnapshot(
      q1,
      (snap) => {
        const rows = [];
        snap.forEach((d) => {
          const x = d.data();
          const when =
            toDate(x.scheduledFor) ||
            toDate(x.runAt) ||
            toDate(x.startsAt) ||
            null;

          rows.push({
            id: d.id,
            status: x.status || 'scheduled',
            time: when,
            keyword: x.keyword || '',
            market: x.market || x.state || '—',
            type: x.type || 'Wholesale',
            target: x.target ?? 100,
            env: x.env || '',
            error: x.error || '',
            automated: !!x.automated || x.createdBy === 'scheduler',
          });
        });

        // Keep *upcoming* first; drop anything far in the past
        const now = Date.now();
        const cleaned = rows
          .filter(r => !r.time || r.time.getTime() > now - 24 * 3600 * 1000) // last 24h & future
          .sort((a, b) => (a.time?.getTime() ?? 0) - (b.time?.getTime() ?? 0));

        setScheduled(cleaned);
        setScheduledLoading(false);
      },
      (err) => {
        setScheduledError(err?.message || String(err));
        setScheduledLoading(false);
      }
    );
  } catch (e) {
    setScheduledError(e?.message || String(e));
    setScheduledLoading(false);
  }
}
function isTreeScrapeRow(row) {
  const t = String(row?.type || '').toLowerCase();
  const tid = String(row?.typeId || '').toLowerCase();

  // tolerant: accept "Tree Service", "tree-service", or tags containing it
  if (t.includes('tree')) return true;
  if (tid === 'tree-service') return true;
  if (Array.isArray(row?.tags)) {
    return row.tags.some(tag => {
      const id = String(tag?.id || tag).toLowerCase();
      return id.includes('type:tree-service') || id === 'tree' || id.includes('tree');
    });
  }
  return false;
}
const ND_SUBTYPE_FILTERS = [
  { key: 'all',           label: 'All',              Icon: AppsIcon },
  { key: 'general',       label: 'General',          Icon: ChatBubbleOutlineIcon },
  { key: 'plumbing',      label: 'Plumbing',         Icon: PlumbingIcon },
  { key: 'hvac',          label: 'HVAC',             Icon: AcUnitIcon },
  { key: 'electrical',    label: 'Electrical',       Icon: ElectricBoltIcon },
  { key: 'roofing',       label: 'Roofing',          Icon: RoofingIcon },
  { key: 'handyman',      label: 'Handyman',         Icon: HandymanIcon },
  { key: 'painting',      label: 'Painting',         Icon: FormatPaintIcon },
  { key: 'treeservice',   label: 'TreeService',     Icon: YardIcon },
  { key: 'pest',          label: 'Pest',             Icon: PestControlIcon },
  { key: 'cleaning',      label: 'Cleaning',         Icon: CleaningServicesIcon },
  { key: 'remodel',       label: 'Remodel',          Icon: HomeRepairServiceIcon },
];

// normalize your post.subtype → 'plumbing' | 'general' | ...
const normSubtype = (s='') => String(s).trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
const filteredScrapeLogs = useMemo(() => {
  if (scrapeView === 'tree') {
    return scrapeLogs.filter(isTreeScrapeRow);
  }
  // wholesale view = "everything else"
  return scrapeLogs.filter(r => !isTreeScrapeRow(r));
}, [scrapeLogs, scrapeView]);
function detachScheduledListener() {
  try { scheduledUnsubRef.current && scheduledUnsubRef.current(); } catch {}
  scheduledUnsubRef.current = null;
}
React.useEffect(() => {
  if (source !== 'saved') return;       // ⬅️ only infinite-scroll on Saved view
  const el = sentinelRef.current; 
   if (!el) return;

  const io = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && hasMore && !loadingMore) {
        handleLoadSaved({ initial: false });
      }
    },
    { root: null, rootMargin: '800px 0px', threshold: 0 } // prefetch before reaching bottom
  );

  io.observe(el);
  return () => io.disconnect();
}, [hasMore, loadingMore, source]);  // normalize to start of day / end of day (local time)
function startOfDayLocal(d) {
  const x = new Date(d);
  x.setHours(0,0,0,0);
  return x;
}
function endOfDayLocal(d) {
  const x = new Date(d);
  x.setHours(23,59,59,999);
  return x;
}
const startOfDayMs = (d) => {
  if (!d) return null;
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.getTime();
};

const endOfDayMs = (d) => {
  if (!d) return null;
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x.getTime();
};



// Get a comparable timestamp off each post
const getPostTimeMs = (post) => {
  // try the cleanest first
  if (post.capturedAt) return Number(post.capturedAt);
  if (post.meta && post.meta.capturedAt) return Number(post.meta.capturedAt);
  if (post.timestamp) return Number(post.timestamp); // fallback to FB post time
  return null;
};
// 🟢 NEW: toggle helper
const toggleBrad = async (post, e) => {
  if (e) e.stopPropagation?.();
  const key = makeKey(post);
  const next = new Set(bradKeys);
  try {
    if (next.has(key)) {
      await removeFromBradLeads(post);
      next.delete(key);
    } else {
      await addToBradLeads(post);
      next.add(key);
    }
    setBradKeys(next);
  } catch (err) {
    console.warn('Brad toggle error:', err);
    setError(err?.message || String(err));
  }
};

// 🟢 NEW: view Brad

const requestAi = async () => {
  const id = ++reqIdRef.current;
  setAiLoading(true);
  setAiError('');
  try {
    const listRaw = await fetchAiSuggestions({
      keyword,
      state: nationwide ? 'Nationwide' : state,
      type: campaignType,
    });

    // Prefer upvoted; if none, fall back to score-based
    const sorted = (listRaw || []).sort(
      (a, b) =>
        (b.thumbsUp || 0) - (a.thumbsUp || 0) ||
        (b.score || 0) - (a.score || 0)
    );

    let list = sorted.filter(s => (s.thumbsUp ?? 0) > 0).slice(0, 8);
    if (list.length === 0) {
      // fallback: keep reasonable confidence suggestions
      list = sorted.filter(s => (s.score ?? 0) >= 0.3).slice(0, 8);
    }

    if (id === reqIdRef.current) setAiSuggestions(list);
  } catch (e) {
    if (id === reqIdRef.current) {
      setAiError(e?.message || String(e));
    }
  } finally {
    if (id === reqIdRef.current) setAiLoading(false);
  }
};

// ---------- Debounce: trigger on input changes ----------
useEffect(() => {
  if (aiSuggestTimer.current) clearTimeout(aiSuggestTimer.current);

  // skip empty
  if (!keyword.trim()) {
    setAiError('');
    setAiSuggestions([]);
    return;
  }

  aiSuggestTimer.current = setTimeout(() => {
    requestAi();
  }, 350);

  return () => {
    if (aiSuggestTimer.current) clearTimeout(aiSuggestTimer.current);
  };
}, [keyword, state, nationwide, campaignType]);
useEffect(() => {
  localStorage.setItem('devMode', devMode ? '1' : '0');
}, [devMode]);
// ---------- Fetch on focus (if nothing cached) ----------
useEffect(() => {
  if (kwFocused && keyword.trim() && aiSuggestions.length === 0 && !aiLoading) {
    requestAi();
  }
}, [kwFocused]); // eslint-disable-line react-hooks/exhaustive-deps

  // 3) on focus, fetch if nothing cached
  useEffect(() => {
    if (
      kwFocused &&
      keyword.trim() &&
      aiSuggestions.length === 0 &&
      !aiLoading
    ) {
      requestAi();
    }
  }, [kwFocused]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    (async () => {
      try {
        const saved = await loadSavedLeads(1000);
        setSavedKeys(new Set(saved.map(p => makeKey(p))));
      } catch {}
    })();
  }, []);

  // Debounced AI suggestions on input changes

// Only accept items that came from the "newscrapes" collection
const isNewscrapesLead = (p) =>
  p?.source === 'newscrapes' ||
  p?.collection === 'newscrapes' ||
  !!p?.scrapeId ||
  !!p?.sourceScrapeId;


async function persistAiSummary(post, sum) {
  if (!db || !post || !sum) return;
  const id = makeKey(post);
  const payload = {
    aiSummary: {
      verdict: sum.verdict || '',
      text: sum.text || '',
      savedAt: serverTimestamp(),
    },
  };
  await Promise.allSettled([
    setDoc(doc(db, COLL, id), payload, { merge: true }),
    setDoc(doc(db, COLL_BRAD, id), payload, { merge: true }),
  ]);
}


// 🟢 NEW: dedicated collection for Brad picks
const COLL_BRAD = 'bradLeads';



// 🟢 NEW: add/remove/load Brad picks
async function addToBradLeads(post) {
  if (!db) return;
  const id = makeKey(post);

  // mirror a doc into `brad_leads`
  await setDoc(doc(db, COLL_BRAD, id), {
    ...post,
    _key: id,
    brad: { saved: true, savedAt: serverTimestamp() },
  }, { merge: true });

  // mark the main doc too (helps filters/search)
  await setDoc(doc(db, COLL, id), {
    brad: { saved: true, savedAt: serverTimestamp() },
    type: post.type || 'Brad Leads',
  }, { merge: true });
}

async function removeFromBradLeads(post) {
  if (!db) return;
  const id = makeKey(post);
  await deleteDoc(doc(db, COLL_BRAD, id));
  await setDoc(doc(db, COLL, id), { brad: { saved: false } }, { merge: true });
}

async function loadBradLeads(limitTo = 5) {
  if (!db) return [];
  const q1 = query(collection(db, COLL_BRAD), orderBy('brad.savedAt', 'desc'), limit(limitTo));
  const snap = await getDocs(q1);
  const rows = [];
  snap.forEach(d => rows.push(d.data()));
  return dedupePosts(rows);
}

// 🟢 NEW: write skip-trace details back to a lead (main + brad mirror if present)
async function attachSkipTraceToLead(post, detail) {
  if (!db || !post || !detail) return;

  const id = makeKey(post);
  const phoneDetails = Array.isArray(detail?.['All Phone Details'])
    ? detail['All Phone Details']
    : Array.isArray(detail?.AllPhoneDetails)
    ? detail.AllPhoneDetails
    : [];

  const payload = {
    skipTrace: {
      summary:   getSummary(detail),
      phones:    getPhones(detail),      // normalized [{ raw, type, last, provider }]
      emails:    getEmails(detail),      // normalized [string]
      addresses: getAddresses(detail),
      relatives: getRelatives(detail),
      phoneDetails,                      // raw detailed phone rows (for CSV meta)
      details:   detail,                 // optional full payload
      storedAt: serverTimestamp(),
      source: 'rapidapi/skip-tracing-working-api',
    },
  };

  await Promise.allSettled([
    setDoc(doc(db, COLL, id), payload, { merge: true }),
    setDoc(doc(db, COLL_BRAD, id), payload, { merge: true }),
  ]);
}
function closeScrapeLogDialog() {
  setLogOpen(false);
  setLogScrapeId(null);
  setLogLines([]);
  if (logUnsubRef.current) { try { logUnsubRef.current(); } catch {} logUnsubRef.current = null; }
}
// only a confidence percentage pill

// ===== Skip Trace helpers (scoring + field mappers) =====
// ===== Skip Trace helpers (robust parsing + scoring tuned to "Lives in") =====
// ===== Skip Trace helpers (DMV-first scoring, robust parsing) =====
const STATE_NAME_TO_POSTAL = {
  'ALABAMA':'AL','ALASKA':'AK','ARIZONA':'AZ','ARKANSAS':'AR','CALIFORNIA':'CA','COLORADO':'CO',
  'CONNECTICUT':'CT','DELAWARE':'DE','DISTRICT OF COLUMBIA':'DC','WASHINGTON, DC':'DC','WASHINGTON DC':'DC','D.C.':'DC','DC':'DC',
  'FLORIDA':'FL','GEORGIA':'GA','HAWAII':'HI','IDAHO':'ID','ILLINOIS':'IL','INDIANA':'IN','IOWA':'IA','KANSAS':'KS','KENTUCKY':'KY',
  'LOUISIANA':'LA','MAINE':'ME','MARYLAND':'MD','MASSACHUSETTS':'MA','MICHIGAN':'MI','MINNESOTA':'MN','MISSISSIPPI':'MS','MISSOURI':'MO',
  'MONTANA':'MT','NEBRASKA':'NE','NEVADA':'NV','NEW HAMPSHIRE':'NH','NEW JERSEY':'NJ','NEW MEXICO':'NM','NEW YORK':'NY',
  'NORTH CAROLINA':'NC','NORTH DAKOTA':'ND','OHIO':'OH','OKLAHOMA':'OK','OREGON':'OR','PENNSYLVANIA':'PA','RHODE ISLAND':'RI',
  'SOUTH CAROLINA':'SC','SOUTH DAKOTA':'SD','TENNESSEE':'TN','TEXAS':'TX','UTAH':'UT','VERMONT':'VT','VIRGINIA':'VA',
  'WASHINGTON':'WA','WEST VIRGINIA':'WV','WISCONSIN':'WI','WYOMING':'WY'
};
const DMV = new Set(['DC','MD','VA']);

const normStr = (s) => String(s ?? '').trim();
const upper = (s) => normStr(s).toUpperCase();
const firstNonEmpty = (...vals) => vals.find(v => v != null && String(v).trim() !== '') ?? '';

const recId = (r) => firstNonEmpty(r['Person ID'], r.PersonID, r.id, r.Id);
const recName = (r) => firstNonEmpty(r.Name, r['Full Name'], r.PersonName, r['Person Name'], r.Person, r.FullName);
const recLivesIn = (r) => firstNonEmpty(
  r['Lives in'], r.LivesIn, r.Lives_in, r.Lives, r.Address, r.address,
  (r.City && r.State) ? `${r.City}, ${r.State}` : ''
);
const STATES = {
  'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
  'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
  'DC': 'District of Columbia', 'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii',
  'ID': 'Idaho', 'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
  'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
  'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
  'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
  'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
  'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
  'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island',
  'SC': 'South Carolina', 'SD': 'South Dakota', 'TN': 'Tennessee',
  'TX': 'Texas', 'UT': 'Utah', 'VT': 'Vermont', 'VA': 'Virginia',
  'WA': 'Washington', 'WV': 'West Virginia', 'WI': 'Wisconsin', 'WY': 'Wyoming',
};
async function sendFeedbackToBackend(post, verdict, reason) {
  const payload = {
    verdict: verdict === 'up' ? 'up' : 'down',
    text: cleanFbNoise(post?.text || ''),
    author: post?.author || null,
    permalink: post?.permalink || post?.profileUrl || null,
    market: post?.market || post?.searchMarket || '__NATIONWIDE__',
    tags: Array.isArray(post?.tags)
      ? post.tags.map(t => ({ id: t.id, label: t.label, color: t.color })).slice(0, 20)
      : [],
    ownerScore: Number.isFinite(post?.ownerScore) ? post.ownerScore : null,
    prospectorScore: Number.isFinite(post?.prospectorScore) ? post.prospectorScore : null,
    classification: post?.classification || null,
    reason: reason || '',
    searchPhrase: post?.searchPhrase || '',
    searchMarket: post?.searchMarket || '',
    searchType: post?.searchType || '',
    capturedAt: post?.capturedAt || null,
    platform: post?.platform || 'facebook',
  };
  return apiFetch('/feedback', { method: 'POST', body: payload });
}

// Count passed/failed/total for a scrapeId from the same leads coll you're using elsewhere
async function deriveCountsFromLeads(db, runId) {
  // NOTE: COLL is 'scrape1' in your file; that’s where your leads live.
  const snap = await getDocs(
    query(collection(db, COLL), where('scrapeId', '==', runId))
  );

  let passed = 0;
  let failed = 0;

  snap.forEach((d) => {
    // using data() is fine; verdict is stored on the lead docs
    const v = d.data()?.verdict;
    if (v === 'good') passed++;
    else if (v === 'bad') failed++;
  });

  return { passed, failed, total: snap.size };
}
function getLeadDomain(lead) {
  const t = String((lead && (lead.meta && lead.meta.type)) || lead && lead.type || '').toLowerCase();
  const c = String((lead && lead.classification) || '').toLowerCase();
  const tags = Array.isArray(lead && lead.tags) ? lead.tags.map(x => String((x && x.id) || x || '').toLowerCase()) : [];

  // tree signals
  if (t.includes('tree')) return 'tree';
  if (c === 'tree' || c.includes('tree')) return 'tree';
  if (tags.some(id => id.includes('type:tree') || id.includes('tree'))) return 'tree';

  // wholesale signals (so we can mark unknowns as wholesale by default later)
  if (t.includes('wholesale') || c === 'wholesale' || c.includes('wholesale')) return 'wholesale';

  return 'unknown';
}

// Normalized "when did we capture this" in ms


function normalizeVerdict(v) {
  const s = String(v || '').toLowerCase();
  if (['good','pass','approve','approved'].includes(s)) return 'good';
  if (['medium','maybe','borderline'].includes(s)) return 'medium';
  // everything else → bad
  return 'bad';
}
function makeKey(lead) {
  const domain = getLeadDomain(lead);
  const idish =
    (lead && lead._id) ||
    (lead && lead.permalink) ||
    (lead && lead.profileUrl) ||
    (lead && lead.text) ||
    Math.random().toString(36).slice(2);
  return `${domain}|${idish}`;
}
// In parent (PropertyGuys)

// In parent
const aiSummaryCacheRef = useRef(new Map());     // key -> summary object
const aiInFlightRef     = useRef(new Map());     // key -> Promise

async function fetchAiLeadSummaryOnce(lead) {
  const key = stableLeadKey(lead);
  if (!key) throw new Error('Missing stable lead key');

  // Return cached result immediately
  if (aiSummaryCacheRef.current.has(key)) {
    return aiSummaryCacheRef.current.get(key);
  }
  // Return in-flight promise if someone already started it
  if (aiInFlightRef.current.has(key)) {
    return aiInFlightRef.current.get(key);
  }

  // Start one request and memoize the promise
  const p = (async () => {
    // TODO: pick ONE endpoint here; don’t branch-call both
    // e.g., Nextdoor-only:
    const res = await fetch('/ai/nextdoor-summary', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        post:  { text: (lead?.text || '').trim(), author: lead?.author },
        scores:{ ownerScore: lead?.ownerScore, prospectorScore: lead?.prospectorScore },
        meta:  { market: lead?.market, type: lead?.type }
      })
    });
    if (!res.ok) throw new Error(`AI summary ${res.status}`);
    const sum = await res.json();
    aiSummaryCacheRef.current.set(key, sum);
    return sum;
  })()
    .finally(() => {
      aiInFlightRef.current.delete(key);
    });

  aiInFlightRef.current.set(key, p);
  return p;
}
async function fetchAiLeadSummary(post) {
  // --- helper: domain detection ---
  function getLeadDomain(p) {
    const t = String((p?.meta?.type || p?.type || '')).toLowerCase();
    const c = String(p?.classification || '').toLowerCase();
    const tags = Array.isArray(p?.meta?.tags)
      ? p.meta.tags.map(x => String(x?.id || '').toLowerCase())
      : [];
    if (t.includes('tree')) return 'tree';
    if (c === 'tree' || c.includes('tree')) return 'tree';
    if (tags.some(id => id.includes('tree'))) return 'tree';
    return 'wholesale';
  }

  // --- helper: nextdoor detection ---
// helpers
const hasTag = (p, rx) => Array.isArray(p?.tags) && p.tags.some(t => rx.test(String(t?.id || t?.label || '')));


// your existing filteredSorted / base
 const baseAll = Array.isArray(filteredSorted) ? filteredSorted : [];
 // What counts as a standardized Nextdoor scrape:
 const isFromScrape = (p) => p?.source === 'newscrapes' || !!p?.scrapeId || !!p?.sourceScrapeId;
 const isNextdoor   = (p) =>
   String(p?.platform || '').toLowerCase() === 'nextdoor' ||
   String(p?.typeId   || '').toLowerCase() === 'nextdoor' ||
   tagMatch(p, /^SRC_ND$/i);
 const hasPostedAt   = (p) => typeof p?.postedAt === 'number' && p.postedAt > 0;

 const base = onlyScrapes
   ? baseAll.filter(p => isFromScrape(p) && isNextdoor(p) && hasPostedAt(p))
   : baseAll;
// 💡 NEW hard filter: standardized, Nextdoor-only, postedAt present

  // --- helper: verdict normalization ---
  function normalizeVerdict(v) {
    const s = String(v || '').toLowerCase();
    if (['good','pass','approve','approved'].includes(s)) return 'good';
    if (['medium','maybe','borderline'].includes(s)) return 'medium';
    return 'bad';
  }

  // --- helper: build tree prompt (text only, same endpoint) ---
  function buildTreePrompt({ text, market, keyword }) {
    const safeText = String(text || '');
    const safeMarket = String(market || 'N/A');
    const safeKeyword = String(keyword || 'N/A');

    return `
You score Facebook posts for TREE SERVICE leads.

GOAL
- Approve genuine homeowners seeking tree work (removal, trimming, stump, emergency).
- Reject vendor/self-promo or lawn-only services.

RETURN FORMAT
Strict JSON only: {"verdict":"good|medium|bad","reasons":["...","..."]}

INPUT POST
${safeText}

CONTEXT
- Market: ${safeMarket}
- Search keyword: ${safeKeyword}

RULES
GOOD: first-person or clearly hiring for tree removal/trim/stump, emergency needs.
MEDIUM: might be a request but vague.
BAD: vendor ad, self-promo, or unrelated.`;
  }

  const domain = getLeadDomain(post);
  const nextdoor = isNextdoor(post);

  // --- shared payload ---
  const payload = {
    post: {
      author: post?.author || '',
      text: cleanFbNoise ? cleanFbNoise(post?.text || '') : (post?.text || ''),
      lang: post?.lang || 'en',
      translatedEn: post?.translatedEn || '',
      permalink: post?.permalink || '',
      profileUrl: post?.profileUrl || '',
      timestamp: post?.timestamp || null,
      platform: post?.platform || null,
      source: post?.source || null,
    },
    scores: {
      ownerScore: post?.ownerScore ?? null,
      prospectorScore: post?.prospectorScore ?? null,
    },
    meta: {
      classification: post?.classification || '',
      type: post?.type || post?.meta?.type || '',
      typeId: post?.typeId || post?.meta?.typeId || '',
      market: post?.market || post?.searchMarket || '',
      tags: (post?.tags || []).map(t => ({ id: t.id, label: t.label })),
      searchPhrase: post?.searchPhrase || '',
      capturedAt: post?.capturedAt || null,
      platform: post?.platform || 'facebook',
    },
    minSentences: 5,
    maxSentences: 10,
  };

  // include tree prompt only for tree domain (same endpoint logic as before)
  if (domain === 'tree') {
    payload.treePrompt = buildTreePrompt({
      text: post?.text,
      market: post?.market || post?.searchMarket,
      keyword: post?.searchPhrase || '',
    });
  }

  // Pick endpoint: Nextdoor → nextdoor-summary, otherwise general lead-summary
  const primaryEndpoint = nextdoor ? '/ai/nextdoor-summary' : '/ai/lead-summary';

  try {
    const data = await apiFetch(primaryEndpoint, { method: 'POST', body: payload });
    return {
      verdict: normalizeVerdict(data?.verdict || ''),
      text: data?.text || '',
    };
  } catch (err) {
    console.warn(`${primaryEndpoint} failed, fallback to /ai/summary:`, err?.message);
    try {
      const data = await apiFetch('/ai/summary', { method: 'POST', body: payload });
      return {
        verdict: normalizeVerdict(data?.verdict || ''),
        text: data?.text || '',
      };
    } catch (err2) {
      console.error('Both AI summary calls failed:', err2?.message);
      throw err2;
    }
  }
}
async function handleDeleteFromDB(post) {
  if (!post) return;
  const ok = window.confirm('Delete this post from the database and remove it from the list?');
  if (!ok) return;

  setDeleting(true);
  try {
    await deleteOneFromFirestore(post);

    // Remove from current screen lists
    setPosts(prev => prev.filter(p => makeKey(p) !== makeKey(post)));
    setSavedKeys(prev => {
      const next = new Set(prev);
      next.delete(makeKey(post));
      return next;
    });

    // Close modal
    setDetailsOpen(false);
    setSelected(null);
  } catch (e) {
    setError(`[Delete] ${e?.message || e}`);
  } finally {
    setDeleting(false);
  }
}
const effectiveApiBase = devMode ? 'http://localhost:4001' : API_BASE;
const scrapePath = devMode ? '/scrape' : '/scrapes';
function detachScrapeListeners() {
  try { unsubMetaRef.current && unsubMetaRef.current(); } catch {}
  try { unsubLeadsRef.current && unsubLeadsRef.current(); } catch {}
  unsubMetaRef.current = null;
  unsubLeadsRef.current = null;
}

function openScrapeModal(id) {
  setCurrentScrapeId(id);
  setScrapeModalOpen(true);
}

function closeScrapeModal() {
  setScrapeModalOpen(false);
  // optional: keep id/meta visible after close, or clear:
  // setCurrentScrapeId(null);
  // setScrapeMeta(null);
}

/**
 * Subscribe to scrapes/{id} (meta) and scrapes/{id}/leads (rows)
 */


// clean up on unmount
useEffect(() => () => detachScrapeListeners(), []);
// Helper: detect states mentioned in text
function detectMarkets(text = '') {
  const found = new Set();
  const lc = text.toLowerCase();

  for (const [abbr, name] of Object.entries(STATES)) {
    if (lc.includes(name.toLowerCase()) || lc.match(new RegExp(`\\b${abbr}\\b`, 'i'))) {
      found.add(name); // always store full name (e.g. "Tennessee")
    }
  }
  return Array.from(found);
}
function toPostal(stateLike){
  if (!stateLike) return '';
  const u = upper(stateLike);
  if (u.length === 2) return u;
  return STATE_NAME_TO_POSTAL[u] || '';
}
const SuggestBadge = ({ sug }) => {
  const conf = Math.round(Math.max(0, Math.min(1, Number(sug.score ?? 0.5))) * 100);
  const text = Number.isFinite(sug.thumbsUp) ? `👍 ${sug.thumbsUp}` : `${conf}%`;
  return (
    <Box sx={{ ml: 'auto', px: .75, py: .25, fontSize: 10, border: '1px solid #e5e7eb', borderRadius: 1, fontWeight: 700 }}>
      {text}
    </Box>
  );
};
function parseCityState(s){
  // "City, ST" or "City, State"
  const m = String(s||'').match(/^\s*([A-Za-z .'-]+?)\s*,\s*([A-Za-z. ]+)\s*$/);
  if (!m) return { city:'', state:'' };
  return { city: m[1].trim(), state: toPostal(m[2].trim()) };
}
function parseCityStateZipHint(hint){
  const m = String(hint||'').match(/^\s*([A-Za-z .'-]+)\s*,\s*([A-Za-z. ]+)\s*(\d{5})?\s*$/);
  if (!m) return { city:'', state:'', zip:'' };
  return { city: m[1].trim(), state: toPostal(m[2].trim()), zip: (m[3]||'').trim() };
}
function targetStatesFromMarket(market){
  const u = upper(market);
  if (u === 'DMV') return new Set(['DC','MD','VA']);
  // handle named markets in your picker
  if (u in STATE_NAME_TO_POSTAL) return new Set([STATE_NAME_TO_POSTAL[u]]);
  if (u === 'WASHINGTON, DC' || u === 'WASHINGTON DC') return new Set(['DC']);
  return new Set(); // unknown/neutral
}

const loadLogsWithCounts = React.useCallback(async () => {
  setLogsLoading(true);
  setLogsError('');
  try {
    const rows = await loadScrapeLogs(); // you already have this helper
    const withCounts = await Promise.all(
      rows.map(async (row) => {
        if (typeof row.passed === 'number' && typeof row.failed === 'number') {
          return row; // already has counts
        }
        const { passed, failed, total } = await deriveCountsFromLeads(db, row._id || row.id);
        return {
          ...row,
          passed,
          failed,
          total: row.total ?? total,
        };
      })
    );
    setScrapeLogs(withCounts);
  } catch (e) {
    setLogsError(e?.message || String(e));
  } finally {
    setLogsLoading(false);
  }
}, [db]);
function cleanName(n){
  return String(n||'').replace(/[^A-Za-z.' -]/g,' ').replace(/\s+/g,' ').trim();
}

/** DMV-first scoring:
 *  1) If market is DMV: any record in DC/MD/VA outranks non-DMV by a large margin.
 *  2) Within target state(s), exact city match from hint > name exact > has location.
 *  3) If market is a single state (e.g., Maryland), treat that as the only target.
 */
function scoreRecord(r, { market, nameHint, cityStateZipHint }){
  const lives = recLivesIn(r);
  const { city: rCity, state: rState } = parseCityState(lives);
  const statesTarget = targetStatesFromMarket(market);
  const { city: hintCity, state: hintState } = parseCityStateZipHint(cityStateZipHint);

  let score = 0;

  // Market-first weighting
  if (statesTarget.size) {
    if (rState && statesTarget.has(rState)) score += 120;   // strong boost
    else score -= 40;                                       // explicit penalty for non-targets
  } else if (hintState && rState) {
    if (hintState === rState) score += 80;
  }

  // City match (if user provided city)
  if (hintCity && rCity && upper(hintCity) === upper(rCity)) score += 50;

  // Name similarity
  const recN = upper(cleanName(recName(r)));
  const hintN = upper(cleanName(nameHint));
  if (recN && hintN) {
    if (recN === hintN) score += 15;
    else if (recN.includes(hintN) || hintN.includes(recN)) score += 7;
  }

  // Having any location helps a bit
  if (lives) score += 3;

  return score;
}

function scoreSortAndFlag(results, context){
  const scored = (results || []).map(r => ({ ...r, __score: scoreRecord(r, context) }));

  scored.sort((a,b)=>{
    const s = (b.__score||0) - (a.__score||0);
    if (s !== 0) return s;

    // Tie-breakers: is in target state, has livesIn, name asc
    const tgt = targetStatesFromMarket(context.market);
    const aState = parseCityState(recLivesIn(a)).state;
    const bState = parseCityState(recLivesIn(b)).state;
    if (tgt.size) {
      const ai = tgt.has(aState), bi = tgt.has(bState);
      if (ai !== bi) return bi - ai;
    }
    const aHas = !!recLivesIn(a), bHas = !!recLivesIn(b);
    if (aHas !== bHas) return (bHas?1:0) - (aHas?1:0);
    return (recName(a)||'').localeCompare(recName(b)||'');
  });

  // Mark "Most Likely"
  const tgt = targetStatesFromMarket(context.market);
  let topIndex = 0;
  if (tgt.size) {
    const idx = scored.findIndex(r => tgt.has(parseCityState(recLivesIn(r)).state));
    if (idx >= 0) topIndex = idx; // first target-state result wins
  }
  return scored.map((r,i)=>({ ...r, __isTop: i === topIndex && (r.__score||0) > -999 }));
}
function normalizeSuggestions(sugs) {
  if (!Array.isArray(sugs)) return [];
  return sugs
    .map((x) => {
      if (typeof x === 'string') {
        // treat bare strings from the server as valid suggestions
        return { term: x, score: 0.6, thumbsUp: 1, reason: '' };
      }
      const term = x.term || x.query || x.q || '';
      const score = Number.isFinite(x.score) ? x.score : (x.confidence ?? 0.6);
      const thumbsUp = Number.isFinite(x.thumbsUp) ? x.thumbsUp : (x.upVotes ?? 1);
      const reason = x.reason || x.explanation || '';
      return { term, score, thumbsUp, reason };
    })
    .filter((s) => s.term);
}



async function fetchAiSuggestions({ keyword, state, type }) {
  const qs = new URLSearchParams({
    keyword: keyword || '',
    state: state || 'Nationwide',
    type: type || 'Wholesale',
  }).toString();
  const data = await apiFetch(`/ai/suggest?${qs}`);
  return normalizeSuggestions(data?.suggestions || []);
}
// ---------- Details mappers ----------
function phoneMask(raw){
  const digits = String(raw||'').replace(/\D/g,'');
  if (digits.length === 10) return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+1 ${digits.slice(1,4)}-${digits.slice(4,7)}-${digits.slice(7)}`;
  return raw || '';
}
function getPhones(detail){
  const list = detail?.['All Phone Details'] || detail?.AllPhoneDetails || detail?.Phones || [];
  if (!Array.isArray(list)) return [];
  return list.map(p => ({
    raw: firstNonEmpty(p.phone_number, p.number, p.Phone, p.phone),
    type: firstNonEmpty(p.phone_type, p.type, p.Type),
    last: firstNonEmpty(p.last_reported, p.last, p.LastReported),
    provider: p.provider || ''
  })).filter(p => p.raw);
}
function getEmails(detail){
  const e = detail?.['Email Addresses'] || detail?.Emails || detail?.emails || [];
  if (!Array.isArray(e)) return [];
  return e.map(x => (typeof x === 'string' ? x : firstNonEmpty(x.email, x.Email))).filter(Boolean);
}

function findLeadLocally(id) {
  if (!id) return null;
  const idLc = String(id);
  return (posts || []).find(p =>
    p?._key === idLc ||
    displayKey(p) === idLc ||
    p?.postId === idLc
  ) || null;
}
function findLeadLocallyByAnyId(posts, id) {
  if (!id) return null;
  return (posts || []).find(p =>
    p?._key === id ||
    displayKey(p) === id ||
    p?.postId === id
  ) || null;
}

// Constrained lookup: ONLY look inside `newscrapes`
async function fetchLeadByIdOrPostIdFromDB(idOrPostId) {
  // 1) Try document id in the root newscrapes doc (if you store leads as top-level docs)
  const docRef = doc(db, 'newscrapesVA', idOrPostId);
  const snap = await getDoc(docRef);
  if (snap.exists()) return { id: snap.id, ...snap.data() };

  // 2) Otherwise, look in per-scrape leads subcollections:
  // newscrapes/{scrapeId}/leads where postId == idOrPostId
  const q1 = query(
    collectionGroup(db, 'leads'),
    where('postId', '==', idOrPostId),
    where('source', '==', 'newscrapes') // extra guard
  );
  const qs = await getDocs(q1);
  const hit = qs.docs.find(Boolean);
  return hit ? { id: hit.id, ...hit.data() } : null;
}
// Fetch a single lead from Firestore by either _key (doc id) or postId (field)
async function fetchLeadByIdOrPostId(id) {
  if (!db || !id) return null;

  // 1) direct doc lookup (when id is our Firestore key)
  try {
    const ref = doc(db, COLL, id);          // COLL === 'scrape1'
    const snap = await getDoc(ref);
    if (snap.exists()) return snap.data();
  } catch (_) {}

  // 2) query by postId field (when id is Nextdoor's postId like "5g9bB8T6SrN7")
  try {
    const q1 = query(collection(db, COLL), where('postId', '==', id));
    const snap = await getDocs(q1);
    if (!snap.empty) return snap.docs[0].data();
  } catch (_) {}

  return null;
}
function getAddresses(detail){
  const current = detail?.['Current Address Details List'] || detail?.CurrentAddresses || [];
  const previous = detail?.['Previous Address Details'] || detail?.PreviousAddresses || [];

  const normCur = (x)=>({
    line: firstNonEmpty(x.street_address, x.AddressLine, x.Address),
    city: firstNonEmpty(x.address_locality, x.City),
    state: toPostal(firstNonEmpty(x.address_region, x.State)),
    zip: firstNonEmpty(x.postal_code, x.ZIP, x.Zip, x.postalCode),
    span: firstNonEmpty(x.date_range, x.timespan)
  });
  const normPrev = (x)=>({
    line: firstNonEmpty(x.streetAddress, x.AddressLine, x.Address),
    city: firstNonEmpty(x.addressLocality, x.City),
    state: toPostal(firstNonEmpty(x.addressRegion, x.State)),
    zip: firstNonEmpty(x.postalCode, x.ZIP, x.Zip, x.postalCode),
    span: firstNonEmpty(x.timespan, x.date_range)
  });

  const cur = Array.isArray(current) ? current.map(normCur) : [];
  const prev = Array.isArray(previous) ? previous.map(normPrev) : [];

  // de-dupe by line + city + state + zip + span
  const seen = new Set();
  const all = [...cur, ...prev].filter(a => {
    const key = [a.line,a.city,a.state,a.zip,a.span].join('|');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  return all;
}
function getRelatives(detail){
  const rel = detail?.['All Relatives'] || detail?.Relatives || [];
  if (!Array.isArray(rel)) return [];
  return rel.map(r => ({
    name: firstNonEmpty(r.Name, r.name, recName(r)),
    relation: firstNonEmpty(r.relation, r.Relation)
  })).filter(r => r.name);
}
function getSummary(detail){
  const pd = Array.isArray(detail?.['Person Details']) ? detail['Person Details'][0] : null;
  const name = firstNonEmpty(pd?.Person_name, pd?.Name, detail?.Name, detail?.FullName);
  const age  = firstNonEmpty(pd?.Age, detail?.Age, detail?.age);
  const dob  = firstNonEmpty(pd?.Born, detail?.DOB, detail?.dob, detail?.DateOfBirth);
  return { name, age, dob, aka: [] };
}
const beginProgress = () => {
  setProgress(0);
  setPhase('Scraping feed…');
  startTs.current = Date.now();

  // 45 seconds per lead
  expectedMsRef.current = Math.max(1, Number(target) || 1) * 35000;

  if (progressTimer.current) clearInterval(progressTimer.current);
  progressTimer.current = setInterval(() => {
    const elapsed = Date.now() - startTs.current;
    const pct = Math.min(99, Math.floor((elapsed / expectedMsRef.current) * 100));
    setProgress(pct);

    if (pct < 10) setPhase('Starting Up');
    else if (pct < 25) setPhase('Launching Facebook instance');
    else if (pct < 75) setPhase('Vetting leads…');
    else if (pct < 95) setPhase('Pulling details…');
    else setPhase('Finalizing…');

    const remaining = Math.max(0, expectedMsRef.current - elapsed);
    const s = Math.ceil(remaining / 1000);
    setEta(s ? `${s}s left` : '');
  }, 200);
};
const endProgress = ({ force = false } = {}) => {
  const finish = () => {
    if (progressTimer.current) clearInterval(progressTimer.current);
    setProgress(100);
    setPhase('Done');
    setEta('');
    setLoading(false); // <-- close the modal here
  };

  if (force) {
    // Smoothly ramp to 100% then close quickly
    const startPct = Math.min(99, Number(progress) || 0);
    const startAt = Date.now();
    const duration = 400; // ms

    if (progressTimer.current) clearInterval(progressTimer.current);
    progressTimer.current = setInterval(() => {
      const t = Math.min(1, (Date.now() - startAt) / duration);
      const pct = Math.floor(startPct + (100 - startPct) * t);
      setProgress(pct);
      if (t >= 1) {
        clearInterval(progressTimer.current);
        finish();
      }
    }, 50);

    return; // don’t wait any longer
  }

  // If not forced, honor the remaining simulated time
  const elapsed = Date.now() - startTs.current;
  const remaining = Math.max(0, (expectedMsRef.current || 0) - elapsed);
  if (remaining > 0) {
    setTimeout(finish, remaining);
  } else {
    finish();
  }
};
// put beside your other tag constants
const SRC_NEXTDOOR = { id: 'SRC_ND', label: 'nextdoor', color: '#DBEAFE' }; // id matches your filter /^SRC_ND$/i

// optional: quick helper if you didn't add the exported constant set
const ndSubtypeTag = (s) => s ? ({
  id: `TYPE_ND_${String(s).toUpperCase().replace(/[^A-Z0-9]+/g,'_')}`,
  label: `Type · Nextdoor · ${s}`,
  color: '#c7d2fe'
}) : null;

// replace your decorate() with this version (or merge the critical lines)
const decorate = (arr) => {
  const nowIso = new Date().toISOString();

  return (arr || []).map((p) => {
    const baseTags = Array.isArray(p.tags) ? p.tags.slice() : [];

    // infer source/platform from backend fields (prefer what the worker writes)
    const sourceRaw = String(p?.meta?.source || p?.platform || '').toLowerCase();
    const isNextdoor = sourceRaw.includes('nextdoor') ||
                       String(p?.typeId || '').toLowerCase() === 'nextdoor';

    const platform = isNextdoor ? 'nextdoor' : 'facebook';

    // prefer backend-provided fields; fall back to UI context
    const backendCaptured = p?.meta?.capturedAt;
    const captured = backendCaptured ?? nowIso;

    const marketsDetected = detectMarkets(p.text || '');
    const finalMarkets = [...new Set([
      p?.meta?.market || '',
      ...marketsDetected
    ].filter(Boolean))];

    const type = p?.meta?.type || p.type || (isNextdoor ? 'NextDoor' : (campaignType || 'Wholesale'));
    const subtype = p?.meta?.subtype || p.subtype || null;
    const subtypeTag = isNextdoor ? ndSubtypeTag(subtype) : null;

    const sourceTag = isNextdoor ? SRC_NEXTDOOR : SRC_FACEBOOK;

    return {
      ...p,
      platform,
      markets: finalMarkets,
      market: p?.meta?.market || finalMarkets[0] || p.market || 'Unassigned',
      type,
      subtype,
      capturedAt: captured,
      tags: dedupeTagObjs([
        ...baseTags,
        sourceTag,
        ...finalMarkets.map((m) => marketTag(m)),
        typeTag(type),
        ...(subtypeTag ? [subtypeTag] : []),
        capturedTag(typeof captured === 'number' ? new Date(captured).toISOString() : captured),
      ]),
    };
  });
};

  const dedupeTagObjs = (tags=[]) => {
    const seen = new Set();
    const out = [];
    for (const t of tags) {
      const id = t?.id || `${t?.label || ''}`.toLowerCase();
      if (seen.has(id)) continue;
      seen.add(id);
      out.push(t);
    }
    return out;
  };
const refreshLogs = async () => {
  setLogsLoading(true); setLogsError('');
  try {
    await loadLogsWithCounts();
  } catch (e) {
    setLogsError(e?.message || String(e));
  } finally {
    setLogsLoading(false);
  }
};
const handleScrape = async () => {
  if (!keyword.trim() || handleScrape._busy) return;

  handleScrape._busy = true;
  setLoading(true);
  setPosts([]);
  setError('');
  setSource('live');
  beginProgress();

  // OPTIONAL: if a previous run left listeners open
  detachScrapeListeners?.();

 const base = devMode ? DEV_BASE : PROD_BASE;
let path;

if (campaignType === 'NextDoor') {
  path = '/nextdoor-scrapes';
} else if (campaignType === 'Tree Service') {
  path = devMode ? '/tree-scrape' : '/tree-scrapes';
} else {
  path = devMode ? DEV_PATH : PROD_PATH;
}

const url = `${base}${path}`;

  const clientScrapeId = uuidv4();
  const payload = {
    keyword,
    state: nationwide ? 'Nationwide' : (state === 'DMV' ? 'DMV' : state),
    type: campaignType,
  limit: Number(target) || 5,
    automated: false,
    scrapeId: clientScrapeId, // server may keep or replace
  };

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-idempotency-key': clientScrapeId,
      },
      body: JSON.stringify(payload),
    });

    const raw = await res.text();
    if (!res.ok) {
      setError(`HTTP ${res.status} ${raw || ''}`);
      return;
    }

    let data;
    try {
      data = JSON.parse(raw);
    } catch {
      setError('Response was not JSON');
      return;
    }

    // ⬇️ RIGHT HERE — as soon as you have the server id
    const serverScrapeId = data?.scrapeId || clientScrapeId;

    // open the modal immediately so user sees progress
    openScrapeModal(serverScrapeId);

    // start live listeners that stream meta

    // Optional: refresh “Logs” tab now so the new row shows up
    if (activeTab === 'logs') refreshLogs?.();

  } catch (err) {
    setError(err?.message || String(err));
  } finally {
    endProgress({ force: true });
    setLoading(false);
    handleScrape._busy = false;
  }
};
function parseNextdoorDateLabelStrict(label, now = new Date()) {
  if (!label) return null;

  // Normalize and drop any "Neighborhood · <date>" prefix if present
  let s = String(label)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/^.*?·\s*/, '');

  const nowMs = now.getTime();

  // today / yesterday
  if (s === 'today') return nowMs;
  if (s === 'yesterday') return nowMs - 24 * 60 * 60 * 1000;

  // Relative forms: "4h ago", "10 hours ago", "3d", "3 days ago", "45m", "45 minutes ago"
  let m;
  if ((m = s.match(/^(\d+)\s*(minute|minutes|min|m)\s*(ago)?$/i))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 60 * 1000;
  }
  if ((m = s.match(/^(\d+)\s*(hour|hours|hr|h)\s*(ago)?$/i))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 60 * 60 * 1000;
  }
  if ((m = s.match(/^(\d+)\s*(day|days|d)\s*(ago)?$/i))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 24 * 60 * 60 * 1000;
  }
  if ((m = s.match(/^(\d+)\s*(week|weeks|wk|w)\s*(ago)?$/i))) {
    const n = parseInt(m[1], 10);
    return nowMs - n * 7 * 24 * 60 * 60 * 1000;
  }

  // Month/Day forms commonly seen: "11 Oct", "Oct 11", "Oct 11, 2:14 PM" (time ignored)
  const monthMap = {jan:0,feb:1,mar:2,apr:3,may:4,jun:5,jul:6,aug:7,sep:8,oct:9,nov:10,dec:11};

  // "11 Oct" or "11 October"
  if ((m = s.match(/^(\d{1,2})\s+([a-z]{3,9})(?:[, ]|$)/i))) {
    const d = parseInt(m[1], 10);
    const monIdx = monthMap[m[2].slice(0,3)];
    if (monIdx != null) {
      const candidate = new Date(now.getFullYear(), monIdx, d, 12, 0, 0, 0);
      if (candidate.getTime() > nowMs) candidate.setFullYear(candidate.getFullYear() - 1);
      return candidate.getTime();
    }
  }

  // "Oct 11" or "October 11"
  if ((m = s.match(/^([a-z]{3,9})\s+(\d{1,2})(?:[, ]|$)/i))) {
    const d = parseInt(m[2], 10);
    const monIdx = monthMap[m[1].slice(0,3)];
    if (monIdx != null) {
      const candidate = new Date(now.getFullYear(), monIdx, d, 12, 0, 0, 0);
      if (candidate.getTime() > nowMs) candidate.setFullYear(candidate.getFullYear() - 1);
      return candidate.getTime();
    }
  }

  // Unknown pattern
  return null;
}
const keepDoc = (d) => d.ref.path.startsWith('newscrapes/');


// Normalize any Firestore/number/string timestamp → number (ms) or null
const numTs = (v) => {
  if (typeof v === 'number') return v;
  if (v && typeof v.toDate === 'function') return v.toDate().getTime?.() ?? null;
  if (typeof v === 'string') {
    const t = Date.parse(v);
    return Number.isNaN(t) ? null : t;
  }
  return null;
};

async function handleLoadSaved({ initial = false } = {}) {
  if (inFlightRef.current) return;
  inFlightRef.current = true;

  if (initial) setInitialLoading(true);
  else setLoadingMore(true);

  try {
    // 1) Load the batch docs at /newscrapes (this mirrors your console logs)
    const rootsSnap = await getDocs(
      // keep it simple; you can add orderBy('startedAt','desc') later if that field exists
      query(collection(db, 'newscrapes'))
    );

    console.log('📦 newscrapes: found', rootsSnap.size, 'docs');

    const all = [];

    // 2) For each batch, pull its /leads subcollection
    for (const root of rootsSnap.docs) {
      const batchId = root.id;
      const leadsRef = collection(db, 'newscrapes', batchId, 'leads');

      // Prefer postedAt desc if present; fall back to unordered
      let leadsSnap;
      try {
        leadsSnap = await getDocs(query(leadsRef, orderBy('postedAt', 'desc'), limit(PAGE_SIZE)));
      } catch {
        leadsSnap = await getDocs(leadsRef);
      }

      console.log(`— batch ${batchId} → ${leadsSnap.size} lead doc(s)`);

      leadsSnap.forEach((ld) => {
        const data = ld.data();
        all.push({
          id: ld.id,
          ...data,
          _path: ld.ref.path,
          platform: data.platform || 'nextdoor',
          type: data.type || 'NextDoor',
          subtype: data.subtype || 'general',
          // keep both; UI uses captured/post times in different places
          postedAt: numTs(data.postedAt) ?? numTs(data.timestamp) ?? null,
          capturedAt: numTs(data.capturedAt) ?? numTs(data.timestamp) ?? Date.now(),
        });
      });
    }

    // 3) Sort client-side so the grid shows newest first
    all.sort(
      (a, b) =>
        (b.postedAt || 0) - (a.postedAt || 0) ||
        (b.capturedAt || 0) - (a.capturedAt || 0) ||
        (b.text?.length || 0) - (a.text?.length || 0)
    );

    // 4) Push to state (no pagination for now; we can add cursors later if needed)
    setPosts(all);
    setPageCursor(null);
    setHasMore(false);

  } catch (e) {
    setError(e?.message || String(e));
  } finally {
    inFlightRef.current = false;
    if (initial) setInitialLoading(false);
    else setLoadingMore(false);
  }
}




  const toggleHeart = async (post, e) => {
    e.stopPropagation();
    const key = makeKey(post);
    const next = new Set(savedKeys);
    try {
      if (next.has(key)) {
        await removeSavedLead(post);
        next.delete(key);
      } else {
        await saveLead(post);
        next.add(key);
      }
      try {
  await logEvent(post, next.has(key) ? 'saved' : 'unsaved', {});
  if (selected && leadKey(selected) === key) setTimeline(await fetchTimeline(selected));
} catch {}
      setSavedKeys(next);
    } catch (err) {
      console.warn('Heart toggle error:', err);
    }
  };


const openDetails = useCallback(async (post) => {
  // keep the URL in sync with the opened modal
  if (post?.postId && leadId !== post.postId) {
    navigate(`/propertyguys/${post.postId}`, { replace: false });
  }

  // select + open
  setSelected(post);
  setDetailsOpen(true);

  // mark as seen and clear "new" badge in the grid
  markSeen(post);
  const key = makeKey(post);
  setPosts(prev =>
    prev.map(p => (makeKey(p) === key ? { ...p, newLead: false } : p))
  );

  // (optional) fire-and-forget: ensure there's a captured event in the log
  // The modal will fetch the full timeline via fetchTimeline.
  try {
    if (typeof ensureCapturedEvent === 'function') {
      await ensureCapturedEvent(post);
    }
  } catch (_) {
    // swallow; timeline load is handled inside DetailsModal
  }
}, [leadId, navigate, makeKey, markSeen, setPosts, setSelected, setDetailsOpen]);
const closeDetails = React.useCallback(() => {
  setDetailsOpen(false);
  setSelected(null);
  // only strip the id from the URL when closing a deep-linked modal
  if (leadId) navigate('/propertyguys', { replace: true });
}, [leadId, navigate]);
  // Legend & Details state


  // ==================== Skip Trace state/UI ====================
  const [skipOpen, setSkipOpen] = useState(false);
  
  const [skipLoading, setSkipLoading] = useState(false);
  const [skipError, setSkipError] = useState('');
  const [skipMode, setSkipMode] = useState('byname'); // 'byname' | 'byaddress' | 'bynameaddress'
  const [skipQuery, setSkipQuery] = useState({ name: '', street: '', citystatezip: '' });
  const [skipResults, setSkipResults] = useState([]); // PeopleDetails[]
  const [skipPage, setSkipPage] = useState(1);
  const [logOpen, setLogOpen] = useState(false);
const [logLines, setLogLines] = useState([]);
const [logLoading, setLogLoading] = useState(false);
const [logError, setLogError] = useState('');
const [logScrapeId, setLogScrapeId] = useState(null);
  const [skipSelected, setSkipSelected] = useState(null); // chosen person record
  const [skipDetail, setSkipDetail] = useState(null);     // detailsbyID response object
// === Fake Dialer state ===
// tune this if you want 100, 200, etc.

const [callOpen, setCallOpen] = useState(false);
const [callNumber, setCallNumber] = useState('');
const [callStep, setCallStep] = useState(0); // 0: Dialing, 1: Ringing, 2: Connecting, 3: Connected
const [logViewer, setLogViewer] = useState({
  open: false,
  scrapeId: null,
  lines: [],
  loading: false,
  unsub: null,
});
const logEndRef = useRef(null);

const openLog = (scrapeId) => {
  setLogViewer((v) => ({ ...v, open: true, scrapeId, loading: true }));
};
const closeLog = () => {
  logViewer.unsub?.();
  setLogViewer({ open: false, scrapeId: null, lines: [], loading: false, unsub: null });
};






// When URL has :leadId, open; when modal closes, clean URL
useEffect(() => {
  let cancelled = false;
  (async () => {
    if (!leadId) return;

    // 1) in-memory
    let post = findLeadLocallyByAnyId(posts, leadId);

    // 2) fetch from DB if needed
    if (!post) post = await fetchLeadByIdOrPostIdFromDB(leadId);
    if (cancelled) return;

    if (post) {
      // setSelected happens inside openDetails
      openDetails(post);
    } else {
      navigate('/propertyguys', { replace: true });
    }
  })();
  return () => { cancelled = true; };
}, [leadId, posts, openDetails, navigate]); // uses your existing openDetails, setSelected

// When the modal closes, drop :leadId from URL

useEffect(() => {
  if (!logViewer.open || !logViewer.scrapeId) return;

  // ✅ use the subcollection under scrapes/{scrapeId}/logs
const q = query(
  collection(db, 'newscrapes', logViewer.scrapeId, 'logs'),
  orderBy('ts', 'asc'),
  limit(1000)
);

  const unsub = onSnapshot(q, (snap) => {
    const lines = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    setLogViewer((v) => ({ ...v, lines, loading: false }));
  }, (err) => {
    console.error('logViewer error:', err);
    setLogViewer((v) => ({ ...v, loading: false }));
  });

  return unsub;
}, [logViewer.open, logViewer.scrapeId]);

useEffect(() => {
  if (logViewer.open) logEndRef.current?.scrollIntoView({ behavior: 'smooth' });
}, [logViewer.lines, logViewer.open]);
const callTimerRef = useRef(null);
const logUnsubRef = useRef(null);
const levelColor = (level) =>
  level === 'error' ? 'error' : level === 'debug' ? 'default' : 'success';

const openDialer = (rawNumber) => {
  const masked = phoneMask(rawNumber);
  setCallNumber(masked || rawNumber || '');
  setCallStep(0);
  setCallOpen(true);

  // log a call event
  if (selected) {
    logEvent(selected, 'call', { number: rawNumber }).then(async () => {
      setTimeline(await fetchTimeline(selected));
    }).catch(()=>{});
  }

  if (callTimerRef.current) clearInterval(callTimerRef.current);
  callTimerRef.current = setInterval(() => {
    setCallStep((s) => (s >= 3 ? (clearInterval(callTimerRef.current), 3) : s + 1));
  }, 1200);
};

const closeDialer = () => {
  if (callTimerRef.current) clearInterval(callTimerRef.current);
  setCallOpen(false);
  setCallNumber('');
  setCallStep(0);
};
// When the Details modal opens on a post, fetch once & cache by key
useEffect(() => {
  if (!detailsOpen || !selected) return;

  const key = makeKey(selected);

  if (aiSummaryCacheRef.current.has(key)) {
    setAiSummary(aiSummaryCacheRef.current.get(key));
    setAiSummaryLoading(false);
    setAiSummaryError('');
    return;
  }

  setAiSummary(null);
  setAiSummaryError('');
  setAiSummaryLoading(true);

  fetchAiLeadSummary(selected) // <-- wrapper that defaults to wholesale, uses tree for tree leads
    .then(async (sum) => {
      aiSummaryCacheRef.current.set(key, sum);
      setAiSummary(sum);
      try { await persistAiSummary(selected, sum); } catch (e) {}
    })
    .catch((err) => {
      setAiSummaryError((err && err.message) || 'Could not load AI summary');
    })
    .finally(() => setAiSummaryLoading(false));
}, [detailsOpen, selected]);
useEffect(() => {
  return () => { if (callTimerRef.current) clearInterval(callTimerRef.current); };
}, []);
  const prefillSkipTrace = (post) => {
    const name = guessNameFromAuthor(post?.author || '');
    const citystatezip = extractCityStateZip(post?.text || '');
    setSkipMode(citystatezip ? 'bynameaddress' : 'byname');
    setSkipQuery({ name, street: '', citystatezip });
    setSkipResults([]);
    setSkipSelected(null);
    setSkipDetail(null);
    setSkipError('');
  };

  const handleOpenSkipTrace = () => {
    if (selected) prefillSkipTrace(selected);
    setSkipOpen(true);
  };
  const handleCloseSkipTrace = () => { setSkipOpen(false); };

  const doSkipSearch = async (page=1) => {
    setSkipLoading(true);
    setSkipError('');
    setSkipResults([]);
    setSkipSelected(null);
    setSkipDetail(null);
    try {
      const data = await skipTraceSearch({
        mode: skipMode,
        name: skipQuery.name,
        street: skipQuery.street,
        citystatezip: skipQuery.citystatezip,
        page,
      });
      setSkipResults(Array.isArray(data?.PeopleDetails) ? data.PeopleDetails : []);
      setSkipPage(Number(data?.Page || page));
    } catch (e) {
      setSkipError(e?.message || String(e));
    } finally {
      setSkipLoading(false);
    }
  };

  const getDetailsFor = async (rec) => {
    setSkipSelected(rec);
    setSkipDetail(null);
    setSkipLoading(true);
    setSkipError('');
    try {
      const id = rec?.['Person ID'] || rec?.PersonID || rec?.id;
      if (!id) throw new Error('Missing Person ID');
      const data = await skipTraceDetailsById(id);
      setSkipDetail(data);
    } catch (e) {
      setSkipError(e?.message || String(e));
    } finally {
      setSkipLoading(false);
    }
  };

  // Review dialog state
  const [reviewOpen, setReviewOpen] = useState(false);
  const [reviewVerdict, setReviewVerdict] = useState(null); // 'up' | 'down'
  const [reviewReason, setReviewReason] = useState('');
  const [reviewSubmitting, setReviewSubmitting] = useState(false);

  const openReview = (verdict) => {
    setReviewVerdict(verdict);         // 'up' or 'down'
    setReviewReason('');
    setReviewOpen(true);
  };
  const closeReview = () => {
    setReviewOpen(false);
    setReviewVerdict(null);
    setReviewReason('');
  };
const submitReview = async () => {
  if (!selected) return;

  const reason = reviewReason.trim();
  if (!reason) {
    setError('Please enter a reason.');
    return;
  }

  try {
    setReviewSubmitting(true);

    // 1) Persist the review in Firestore (your existing path)
    await saveReview(selected, reviewVerdict, reason);

    // 2) Update timeline (non-blocking if it fails)
    try {
      await logEvent(
        selected,
        reviewVerdict === 'up' ? 'review_up' : 'review_down',
        { reason }
      );
      setTimeline(await fetchTimeline(selected));
    } catch {
      /* soft-fail */
    }

    // 3) Send feedback to backend learner (single, canonical call)
    await sendFeedbackToBackend(selected, reviewVerdict, reason);

    // 4) Close the dialog
    closeReview();
  } catch (e) {
    setError(e?.message || String(e));
  } finally {
    setReviewSubmitting(false);
  }
};

  // === Filters & sorting ===

const markets = [
  'All',
  'Ohio',
  'Washington, DC',
  'Tennessee',
  'Maryland',
  'Virginia',
  'DMV',
];

// put near other small helpers (module scope or inside the component above useMemo)
const parseMonthDay = (label) => {
  if (!label) return null;
  const m = String(label).match(/\b(\d{1,2})\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Sept|Oct|Nov|Dec)\b/i);
  if (!m) return null;
  const day = parseInt(m[1], 10);
  const monNames = ['jan','feb','mar','apr','may','jun','jul','aug','sep','sept','oct','nov','dec'];
  let mon = monNames.indexOf(m[2].toLowerCase());
  if (mon === 9) mon = 8;            // treat "Sept" as "Sep"
  else if (mon > 8) mon -= 1;        // shift after the "sept" slot
  const now = new Date();
  const d = new Date(now.getFullYear(), mon, day, 12, 0, 0, 0);
  if (d.getTime() > now.getTime()) d.setFullYear(d.getFullYear() - 1);
  return d.getTime();
};

const parseRelative = (label) => {
  if (!label) return null;
  const s = String(label).toLowerCase();
  const now = Date.now();
  if (/yesterday/.test(s)) return now - 24*60*60*1000;
  let m;
  if ((m = s.match(/(\d+)\s*(minute|min|m)\b/))) return now - parseInt(m[1],10)*60*1000;
  if ((m = s.match(/(\d+)\s*(hour|hr|h)\b/)))    return now - parseInt(m[1],10)*60*60*1000;
  if ((m = s.match(/(\d+)\s*(day|d)\b/)))        return now - parseInt(m[1],10)*24*60*60*1000;
  if ((m = s.match(/(\d+)\s*(week|wk|w)\b/)))    return now - parseInt(m[1],10)*7*24*60*60*1000;
  return null;
};

// Use this everywhere we need the post's real time (for filters + sorting)
const getPostedAtMs = (p) => {
  if (typeof p?.postedAt === 'number' && p.postedAt > 0) return p.postedAt;
  if (typeof p?.datePosted === 'number' && p.datePosted > 0) return p.datePosted;
  // try label-based parsing
  const fromLabel =
    parseRelative(p?.datePostedLabel) ??
    parseMonthDay(p?.datePostedLabel) ??
    parseRelative(p?.timeLabel) ??
    parseMonthDay(p?.timeLabel);
  if (fromLabel) return fromLabel;
  // absolute fallbacks
  if (typeof p?.timestamp === 'number' && p.timestamp > 0) return p.timestamp;
  if (typeof p?.meta?.capturedAt === 'number') return p.meta.capturedAt;
  if (typeof p?.capturedAt === 'number') return p.capturedAt;
  return 0;
};
const filteredSorted = React.useMemo(() => {
  const toTs = (v) => {
    if (!v && v !== 0) return 0;
    const n = Number(v);
    if (!Number.isNaN(n) && n > 0) return n;
    const t = new Date(v).getTime();
    return Number.isNaN(t) ? 0 : t;
  };

  // captured time (used for explicit date range picker & tie-breaks)
  
// Returns true if the lead was captured within the last 24 hours

  let rows = Array.isArray(posts) ? posts.slice() : [];

  // Checkbox window (5d / 14d / 30d) — based on real posted time
// Checkbox window (5d / 14d / 30d) — based on posted OR captured time
let daysFilter = null;
if (showPast5DaysOnly) daysFilter = 5;
else if (showPast2WeeksOnly) daysFilter = 14;
else if (showRecentOnly) daysFilter = 30;

if (daysFilter != null) {
  const cutoff = Date.now() - daysFilter * 24 * 60 * 60 * 1000;
  rows = rows.filter((r) => (getPostedAtMs(r) || getCapturedMs(r)) >= cutoff);
}

  // Hide reviewed leads except in thumbs_up/down

  


  // Type filter
  if (filterType !== 'All') {
    const want = String(filterType).toLowerCase();
    rows = rows.filter((r) => {
      const t   = String(r?.type || '').toLowerCase();
      const src = String(r?.platform || r?.meta?.source || '').toLowerCase();
      const tagIds = Array.isArray(r?.tags) ? r.tags.map(x => String(x?.id || '').toLowerCase()) : [];
      if (want === 'nextdoor') {
        return t === 'nextdoor' || src === 'nextdoor' || tagIds.includes('type:nextdoor') || tagIds.includes('src_nd');
      }
      return t === want;
    });
  }

  // Market filter
  if (filterMarket !== 'All') {
    const normFilter = String(filterMarket).toLowerCase();
    rows = rows.filter((r) => {
      if (r.market && String(r.market).toLowerCase().includes(normFilter)) return true;
      if ((r.markets || []).some((m) => m && String(m).toLowerCase().includes(normFilter))) return true;
      if ((r.tags || []).some((t) => String(t?.label || '').toLowerCase().includes(normFilter))) return true;
      return false;
    });
  }

  // Score filters
  const minO = Number(minOwner);
  const maxP = Number(maxProspector);
  if (!Number.isNaN(minO) && String(minOwner) !== '') {
    rows = rows.filter((r) => Number(r.ownerScore || 0) >= minO);
  }
  if (!Number.isNaN(maxP) && String(maxProspector) !== '') {
    rows = rows.filter((r) => Number(r.prospectorScore || 0) <= maxP);
  }

  // Explicit date range (your "Fetch by Date" picker) — OK to base on captured time
  if (activeDateWindow && activeDateWindow.startMs && activeDateWindow.endMs) {
    const { startMs, endMs } = activeDateWindow;
    rows = rows.filter((r) => {
      const t = getCapturedMs(r);
      return t && t >= startMs && t <= endMs;
    });
  }

  // Sorting
  if (sortBy === 'relevant') {
    rows.sort((a, b) => {
      const ao = Number(a.ownerScore || 0), bo = Number(b.ownerScore || 0);
      const ap = Number(a.prospectorScore || 0), bp = Number(b.prospectorScore || 0);
      if (bo !== ao) return bo - ao;                 // higher ownerScore first
      if (ap !== bp) return ap - bp;                 // lower prospectorScore first
      return getPostedAtMs(b) - getPostedAtMs(a);    // newer postedAt as tie-break
    });
  } else {
    rows.sort((a, b) => getPostedAtMs(b) - getPostedAtMs(a)); // “Most recent” = by postedAt
  }

  return rows;
}, [
  posts,
  source,
  filterType,
  filterMarket,
  minOwner,
  maxProspector,
  sortBy,
  activeDateWindow,
  showPast5DaysOnly,
  showPast2WeeksOnly,
  showRecentOnly
]);
  // Tags in details modal — greens vs reds
    const isLCSelected = useMemo(() => {
    const t = (selected?.type || '').toLowerCase();
    if (t === 'lawncare' || t === 'landscaping') return true;
    return (selected?.tags || []).some(tag => /^LC/.test(tag?.id || ''));
  }, [selected]);
  const isRoofingSelected = useMemo(() => {
  const t = (selected?.type || '').toLowerCase();
  if (t === 'roofing') return true;
  return (selected?.tags || []).some(tag => /^RT/.test(tag?.id || ''));
}, [selected]);

// simple helper you can reuse everywhere
const tagMatch = (p, rx) =>
  Array.isArray(p?.tags) &&
  p.tags.some(t => rx.test(String(t?.id || t?.label || '')));
const isTreeServiceSelected = String(filterType || campaignType).toLowerCase() === 'tree service';
const ownerTags = useMemo(() => {
  const tags = selected?.tags || [];

  if (isLCSelected) {
    // Lawncare “need” signals (show all LC* except vendor)
    return tags.filter(t => /^LC(?!V)/.test(t.id));
  }

  if (isRoofingSelected) {
    // Roofing “buyer” signals: all RT* except RTV/RTX (vendor/spam)
    return tags.filter(t => /^RT(?!V|X)/.test(t.id));
  }

  if (isTreeServiceSelected) {
    // Tree Service “need” signals: all TS* except TSV (vendor)
    return tags.filter(t => /^TS(?!V)/.test(t.id));
  }

  // Wholesale / default
  return tags.filter(t => /^(D\d+|DOV|R)$/.test(t.id));
}, [selected, isLCSelected, isRoofingSelected, isTreeServiceSelected]);

const prospectorTags = useMemo(() => {
  const tags = selected?.tags || [];

  if (isLCSelected) {
    // Lawncare vendor
    return tags.filter(t => /^LCV$/.test(t.id));
  }

if (isRoofingSelected) {
  // Roofing vendor/spam only
  return tags.filter(t => /^RT(V|X)$/.test(t.id));
}

if (isTreeServiceSelected) {
  // Tree Service vendor only
  return tags.filter(t => /^TSV$/.test(t.id));
}

// Wholesale / default
return tags.filter(t => /^(B\d+|B0|N\d+|REVIEW)$/.test(t.id));
}, [selected, isLCSelected, isRoofingSelected, isTreeServiceSelected]);


  const extraTags = useMemo(() => (selected?.tags || []).filter(t => /^(SRC_|MKT_|TYPE_|CAP_)/.test(t.id)), [selected]);

function isNewLead(p) {
  const ms = getPostedAtMs(p);   // actual post time, not captured time
  if (!ms) return false;
  const ageHrs = (Date.now() - ms) / 3_600_000;
  const key = makeKey(p);
  return ageHrs <= 24 && !seenKeys.has(key);
}
  return (
    
    <Box sx={{ backgroundColor: '#f9fafb', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', px: 2, py: 4 }}>
      {/* Header */}
      {/* === Centered Leads / Logs toggle === */}

{activeTab === 'logs' && (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: '100vh',
      pt: 4,
      width: '100%',
    }}
  >
    {/* === Centered Logo === */}
    {/* <Box
      component="img"
      src={logo}
      alt="Logo"
      sx={{ height: 60, objectFit: 'contain', mb: 3 }}
    /> */}

    {/* ======= Scheduled (upcoming) scrapes — dummy data ======= */}


    {/* ======= Main: Scrape Logs (FULL WIDTH) ======= */}
    <Container
      maxWidth={false}
      sx={{
        width: '100%',
        px: { xs: 2, md: 4 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          mb: 2,
        }}
      >
        
      </Box>

      {!!logsError && <Typography color="error" sx={{ mb: 1 }}>{logsError}</Typography>}

      {/* ─────────────── SCRAPE LOGS ─────────────── */}
<Box sx={{ my: 3 }}>
  {/* Header row: title left, refresh right */}
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
    <Typography variant="h6" fontWeight={700}>Scrape Logs</Typography>
    <Button size="small" variant="outlined" onClick={refreshLogs}>Refresh</Button>
  </Box>

  {/* ===== Centered Toggle Row ===== */}
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      mb: 2,
    }}
  >
    <Box
      role="tablist"
      aria-label="Log type"
      sx={{
        display: 'inline-flex',
        borderRadius: 9999,
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        bgcolor: '#fff',
      }}
    >
      <Button
        role="tab"
        aria-selected={scrapeView === 'wholesale'}
        onClick={() => setScrapeView('wholesale')}
        size="small"
        sx={{
          px: 3,
          py: 1,
          borderRadius: 0,
          fontWeight: 600,
          textTransform: 'none',
          bgcolor: scrapeView === 'wholesale' ? '#111827' : 'transparent',
          color:   scrapeView === 'wholesale' ? '#fff'     : '#111827',
          '&:hover': { bgcolor: scrapeView === 'wholesale' ? '#111827' : '#f3f4f6' },
        }}
      >
        Wholesale
      </Button>
      <Button
        role="tab"
        aria-selected={scrapeView === 'tree'}
        onClick={() => setScrapeView('tree')}
        size="small"
        sx={{
          px: 3,
          py: 1,
          borderRadius: 0,
          fontWeight: 600,
          textTransform: 'none',
          bgcolor: scrapeView === 'tree' ? '#065f46' : 'transparent',
          color:   scrapeView === 'tree' ? '#fff'     : '#111827',
          '&:hover': { bgcolor: scrapeView === 'tree' ? '#065f46' : '#f3f4f6' },
        }}
      >
        Tree Service
      </Button>
    </Box>
  </Box>

  {!!logsError && (
    <Typography color="error" sx={{ mb: 1 }}>
      {logsError}
    </Typography>
  )}
  {logsLoading && <LinearProgress sx={{ mb: 2, width: '100%' }} />}

</Box>
    </Container>
  </Box>

)}
      <Box sx={{ width: '100%', maxWidth: 1280, display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>

       
       
{activeTab === 'leads' && (
  <Box
    sx={{
      width: '100%',
      maxWidth: 1280,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      my: 3,
    }}
  >
    {/* Row with two logos */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        mb: 2,
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Logo 1"
        sx={{ height: 54, objectFit: 'contain' }}
      />
      <Box
        component="img"
        src={logo2}
        alt="Logo 2"
        sx={{ height: 70, width:100, objectFit: 'contain' }}
      />
    </Box>



    <Button
      variant="contained"
      color="primary"
      onClick={() => window.location.reload()}
    >
      Refresh Leads
    </Button>

{/* <FormControlLabel
  control={<Checkbox checked={onlyScrapes} onChange={(e)=>setOnlyScrapes(e.target.checked)} />}
  label="Only show standardized Nextdoor scrapes"
/> */}
  </Box>
)}        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap:'wrap' }}>





{/* Logs view */}




        </Box>
      </Box>



      {/* Controls: run a scrape */}
      <Box sx={{ width:'100%', maxWidth:1280, display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center', mb: 1.5 }}>
     






      </Box>












{activeTab === 'leads' && (

     <>
    


<Typography variant="body2" color="text.secondary" mb={2}>
  Source: newscrapes
</Typography>
{/* ───────── Nextdoor Subtype Filter Bar ───────── */}
<Paper
  elevation={0}
  sx={{
    mt: 1,
    mb: 2,
    width: '100%',
    maxWidth: 1280,
    borderRadius: 9999,
    border: '1px solid #e5e7eb',
    bgcolor: '#fff',
    px: 1,
    py: 0.5,
    overflowX: 'auto',
  }}
>
  <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
    {ND_SUBTYPE_FILTERS.map(({ key, label, Icon }) => {
      const active = ndSubtypeFilter === key;
      return (
        <Button
          key={key}
          onClick={() => setNdSubtypeFilter(key)}
          startIcon={
            <Icon
              fontSize="small"
              sx={{ color: active ? '#ffffff' : '#111827' }}
            />
          }
          size="small"
          sx={{
            textTransform: 'none',
            borderRadius: 9999,
            px: 1.5,
            py: 0.5,
            fontWeight: 700,
            transition: 'all 0.2s ease',
            bgcolor: active ? '#10b981' : 'transparent',     // ✅ green when active
            color: active ? '#ffffff' : '#111827',
            '&:hover': {
              bgcolor: active ? '#059669' : '#f3f4f6',       // darker green on hover
            },
          }}
        >
          {label}
        </Button>
      );
    })}
  </Box>
</Paper>
<FormGroup row>
  <FormControlLabel
    control={
      <Checkbox
        checked={showPast5DaysOnly}
        onChange={(e) => {
          // optional: make them mutually exclusive
          setShowPast5DaysOnly(e.target.checked);
          if (e.target.checked) {
            setShowPast2WeeksOnly(false);
            setShowRecentOnly(false);
          }
        }}
      />
    }
    label="Only show leads from past 5 days"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={showPast2WeeksOnly}
        onChange={(e) => {
          setShowPast2WeeksOnly(e.target.checked);
          if (e.target.checked) {
            setShowPast5DaysOnly(false);
            setShowRecentOnly(false);
          }
        }}
      />
    }
    label="Only show leads from past 2 weeks"
  />

  <FormControlLabel
    control={
      <Checkbox
        checked={showRecentOnly}
        onChange={(e) => {
          setShowRecentOnly(e.target.checked);
          if (e.target.checked) {
            setShowPast5DaysOnly(false);
            setShowPast2WeeksOnly(false);
          }
        }}
      />
    }
    label="Only show leads from past month"
  />
</FormGroup>

{!!error && <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>}

<Box
  sx={{
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    mb: 2,
    flexWrap: 'wrap',
  }}
>
  <TextField
    size="small"
    placeholder="Search leads… (author or text)"
    value={leadSearch}
    onChange={(e) => setLeadSearch(e.target.value)}
    InputProps={{ sx: { bgcolor: '#fff' } }}
    sx={{ width: { xs: '100%', sm: 360 } }}
  />
<Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
  {loading
    ? 'Working…'
    : (() => {
        const q = norm(leadSearch).trim();
        const tokens = q.split(/\s+/).filter(Boolean);

        // Build the same canonical list you actually render later
// Lock the screen to ONLY newscrapes leads
 const base = Array.isArray(filteredSorted)
   ? filteredSorted
   : [];
        const isNextdoor = (p) =>
          String(p?.platform || '').toLowerCase() === 'nextdoor' ||
          String(p?.typeId || '').toLowerCase() === 'nextdoor' ||
          tagMatch(p, /^SRC_ND$/i);

        const hasPostedAt = (p) => getPostedAtMs(p) > 0;

        // must have a non-empty subtype (but backfill it like the grid does)
        const hasSubtype = (p) => !!p?.subtype;

        // same flow as the grid:
        // match the exact pipeline used by the grid (no extra gates)
const baseForCount = Array.isArray(posts) ? posts : [];

const withSubtype = baseForCount.map((p) => ({
  ...p,
  subtype: p.subtype ||
           (tagMatch(p, /^LC/) ? 'lawncare' :
            tagMatch(p, /^TS/) ? 'tree' :
            tagMatch(p, /^RT/) ? 'roofing' : 'general'),
}));

const applySubtype = (rows) => {
  if ((filterType || '').toLowerCase() !== 'nextdoor') return rows;
  return ndSubtypeFilter === 'all'
    ? rows
    : rows.filter((p) => normSubtype(p.subtype) === ndSubtypeFilter);
};
const filteredBySubtype = applySubtype(withSubtype);

const sorted = [...filteredBySubtype].sort((a, b) =>
  (getPostedAtMs(b) || 0) - (getPostedAtMs(a) || 0) ||
  (getCapturedMs(b) || 0) - (getCapturedMs(a) || 0) ||
  (b?.text?.length || 0) - (a?.text?.length || 0)
);

const matchesCount = tokens.length
  ? sorted.filter((p) => {
      const hay = textForSearch(p);
      return tokens.every((t) => hay.includes(t));
    }).length
  : sorted.length;

return `Showing ${matchesCount} of ${baseForCount.length} total`;
      })()
  }
</Typography>
</Box>

{logsLoading && <LinearProgress sx={{ mb: 2, width: '100%' }} />}

{(() => {
  const q = norm(leadSearch).trim();
  const tokens = q.split(/\s+/).filter(Boolean);

  // base is your existing list (already date-windowed by the checkboxes)
// Lock the screen to ONLY newscrapes leads
  // 🔴 SHOW EVERYTHING WE GOT FROM `newleads`
  // (no Nextdoor-only gating, no postedAt requirement)
const base = Array.isArray(posts) ? posts : [];
  // Backfill subtype (purely cosmetic)
  const withSubtype = base.map((p) => ({
    ...p,
    subtype:
      p.subtype ||
      (tagMatch(p, /^LC/) ? 'lawncare' :
       tagMatch(p, /^TS/) ? 'tree' :
       tagMatch(p, /^RT/) ? 'roofing' : 'general'),
  }));

  // Keep your subtype bar behavior only if Type === Nextdoor
  const applySubtype = (rows) => {
    if ((filterType || '').toLowerCase() !== 'nextdoor') return rows;
    return ndSubtypeFilter === 'all'
      ? rows
      : rows.filter((p) => normSubtype(p.subtype) === ndSubtypeFilter);
  };

  const filteredBySubtype = applySubtype(withSubtype);

  // 🔴 Sort with robust tie-breakers, but DO NOT drop anything
  const sorted = [...filteredBySubtype].sort((a, b) =>
    (getPostedAtMs(b) || 0) - (getPostedAtMs(a) || 0) ||
    (getCapturedMs(b) || 0) - (getCapturedMs(a) || 0) ||
    (b?.text?.length || 0) - (a?.text?.length || 0)
  );

  // Free-text search only (no extra hidden filters)
  const leadsToShow = tokens.length
    ? sorted.filter((p) => {
        const hay = textForSearch(p);
        return tokens.every((t) => hay.includes(t));
      })
    : sorted;

  const visiblePosts = leadsToShow;

  return (
    <>
      {/* Grid */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: 2,
          width: '100%',
          maxWidth: 1280
        }}
      >
        {visiblePosts.map((post) => {
  const key = displayKey(post);
  const isSaved = savedKeys.has(key);

  return (
    <LeadCard
      key={key}
      post={post}
      isSaved={isSaved}
      cleanFbNoise={cleanFbNoise}
      getPostedAtMs={getPostedAtMs}
      isNewLead={isNewLead}
      onOpen={() => openDetails(post)}
      onToggleHeart={(e) => toggleHeart(post, e)}
    />
  );
})}
      </Box>

      <div ref={sentinelRef} style={{ height: 1 }} />

      {loadingMore && (
        <Typography align="center" variant="body2" sx={{ opacity: 0.7, py: 1 }}>
          Loading…
        </Typography>
      )}
      {!hasMore && !!posts.length && (
        <Typography align="center" variant="caption" sx={{ opacity: 0.7, py: 1 }}>
          No more results
        </Typography>
      )}

      {!loading && visiblePosts.length === 0 && !error && (
        <Typography variant="body2" color="text.secondary" mt={4}>
          No results match your filters (and search). Try clearing them or click “Load All”.
        </Typography>
      )}
    </>
  );
})()}







<Dialog open={scrapeModalOpen} onClose={closeScrapeModal} fullWidth maxWidth="sm">
  <DialogTitle>
    Scrape: {currentScrapeId || '—'}
  </DialogTitle>
  <DialogContent dividers>
    <Stack spacing={1}>
      <Typography variant="body2">
        Status: {scrapeMeta?.status || 'starting…'}
      </Typography>
      {scrapeMeta?.error && (
        <Typography variant="body2" color="error">
          {scrapeMeta.error}
        </Typography>
      )}
      <Typography variant="body2">
        Total leads: {Array.isArray(posts) ? posts.length : 0}
      </Typography>
      {/* add any progress bar, logs, etc. */}
    </Stack>
  </DialogContent>
  <DialogActions>
    <Button onClick={closeScrapeModal}>Close</Button>
  </DialogActions>
</Dialog>
      
<Dialog open={logOpen} onClose={closeScrapeLogDialog} maxWidth="md" fullWidth>
  <DialogTitle sx={{ pr: 6 }}>
    Scrape Log — {logScrapeId || ''}
    <IconButton onClick={closeScrapeLogDialog} sx={{ position:'absolute', right:8, top:8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ bgcolor:'#0b1020', p:0 }}>
    {logLoading && <LinearProgress />}
    {!!logError && <Box sx={{ color:'#fecaca', p:2 }}>{logError}</Box>}

    <Box sx={{
      fontFamily:'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      fontSize: 13,
      lineHeight: 1.4,
      color:'#e5e7eb',
      p: 2,
      maxHeight: 480,
      overflow:'auto',
      whiteSpace: 'pre-wrap',
    }}>
      {logLines.length === 0 && !logLoading ? (
        <Typography variant="body2" sx={{ color:'#a1a1aa' }}>No log lines yet.</Typography>
      ) : (
        logLines.map(l => {
          const t = l.ts?.toDate ? l.ts.toDate().toLocaleTimeString() : '…';
          const lvl = String(l.level || 'info').toUpperCase().padEnd(5,' ');
          const color =
            l.level === 'error' ? '#fecaca' :
            l.level === 'warn' ? '#fde68a' : '#c7d2fe';
          const meta = l.meta ? ` ${JSON.stringify(l.meta).slice(0,300)}` : '';
          return (
            <div key={l.id} style={{ color }}>
              [{t}] {lvl} — {l.msg}{meta}
            </div>
          );
        })
      )}
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={closeScrapeLogDialog} variant="contained">Close</Button>
  </DialogActions>
</Dialog>



  </>
)}














      {/* Details Modal */}
  
  <DetailsModal
  open={detailsOpen}
  selected={selected}
  closeDetails={closeDetails}
  logEvent={logEvent}
  fetchTimeline={fetchTimeline}
  aiSummary={aiSummary}
  aiSummaryLoading={aiSummaryLoading}
  aiSummaryError={aiSummaryError}
  noteText={noteText}
  setNoteText={setNoteText}
  timeline={timeline}
  timelineLoading={timelineLoading}
  setTimeline={setTimeline}
  setTimelineLoading={setTimelineLoading}
  handleGenerateScript={handleGenerateScript}
  callScript={callScript}
  callScriptError={callScriptError}
  callScriptLoading={callScriptLoading}
  copyToClipboard={copyToClipboard}
  canGenerateScript={canGenerateScript}
  handleOpenSkipTrace={handleOpenSkipTrace}
  toggleBrad={toggleBrad}
  bradKeys={bradKeys}
  makeKey={makeKey}
  deleting={deleting}
  handleDeleteFromDB={handleDeleteFromDB}
  saveOneToFirestore={saveOneToFirestore}
  openReview={openReview}
  openSmart={handleOpenSmartComments}
  closeSmart={closeSmart}
  smartOpen={smartOpen}
  smartLoading={smartLoading}
  smartComments={smartComments}
  chosenSuggestion={chosenSuggestion}
  setChosenSuggestion={setChosenSuggestion}
  sendChosen={sendChosen}
  sendError={sendError}
  sending={sending}
  smartError={smartError}
  reviewOpen={reviewOpen}
  closeReview={closeReview}
  reviewVerdict={reviewVerdict}
  reviewReason={reviewReason}
  setReviewReason={setReviewReason}
  submitReview={submitReview}
  reviewSubmitting={reviewSubmitting}
  isLCSelected={isLCSelected}
  isRoofingSelected={isRoofingSelected}
  ownerTags={ownerTags}
  prospectorTags={prospectorTags}
  cleanFbNoise={cleanFbNoise}
/>


<Dialog open={smartOpen} onClose={closeSmart} maxWidth="sm" fullWidth>
  <DialogTitle>
    Smart comment ideas
    <IconButton onClick={closeSmart} sx={{ position: 'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    {smartLoading && <LinearProgress sx={{ mb: 2 }} />}

    {!!smartError && (
      <Typography color="error" variant="body2" sx={{ mb: 1 }}>
        {smartError}
      </Typography>
    )}

    {smartComments.length === 0 && !smartLoading && !smartError && (
      <Typography variant="body2" color="text.secondary">
        Clicked, generating suggestions…
      </Typography>
    )}

{smartComments.length > 0 && (
  <Stack spacing={1.25}>
    {smartComments.map((s, i) => {
      const active = s === chosenSuggestion;
      return (
        <Paper
          key={i}
          variant="outlined"
          sx={{
            p: 1.25,
            borderColor: active ? '#60a5fa' : 'divider',
            bgcolor: active ? '#eff6ff' : 'background.paper',
            cursor: 'pointer'
          }}
          onClick={() => setChosenSuggestion(s)}
        >
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            {s}
          </Typography>
        </Paper>
      );
    })}

    {!!sendError && (
      <Typography variant="body2" color="error">
        {sendError}
      </Typography>
    )}

    <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
      <Button
        size="small"
        variant="contained"
        onClick={sendChosen}
        disabled={!chosenSuggestion || sending}
      >
        {sending ? 'Sending…' : 'Send Smart Comment'}
      </Button>
    </Stack>
  </Stack>
)}
  </DialogContent>
</Dialog>
      {/* Review Dialog */}
      <Dialog open={reviewOpen} onClose={closeReview} maxWidth="sm" fullWidth>
        <DialogTitle>
          {reviewVerdict === 'up' ? 'Approve Lead (Thumbs Up)' : 'Reject Lead (Thumbs Down)'}
          <IconButton onClick={closeReview} sx={{ position:'absolute', right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selected && (
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" sx={{ mb: 0.5 }}>{selected.author}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ whiteSpace:'pre-wrap' }}>
  {cleanFbNoise(selected?.text || '').slice(0, 500)}
  {cleanFbNoise(selected?.text || '').length > 500 ? '…' : ''}
</Typography>
            </Box>
          )}
          <TextField
            autoFocus
            fullWidth
            multiline
            minRows={3}
            label={`Reason for ${reviewVerdict === 'up' ? 'approval' : 'rejection'} (required)`}
            value={reviewReason}
            onChange={(e)=>setReviewReason(e.target.value)}
helperText={
  isLCSelected
    ? 'Be specific (e.g., clear need, owner voice, HOA/code, overgrown, ASAP, not a vendor ad).'
    : 'Be specific (e.g., distress signal, owner-voice, red flags, etc.)'
}          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeReview}>Cancel</Button>
          <Button
            variant="contained"
            disabled={reviewSubmitting || !reviewReason.trim()}
            onClick={submitReview}
          >
            {reviewSubmitting ? 'Saving…' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
{/* Skip Trace Dialog */}
<Dialog open={skipOpen} onClose={handleCloseSkipTrace} maxWidth="md" fullWidth>
  <DialogTitle>
    Skip Trace
    <IconButton onClick={handleCloseSkipTrace} sx={{ position:'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    {/* Query controls */}
    <Grid container spacing={1.25}>
      <Grid item xs={12} md={4}>
        <FormControl size="small" fullWidth>
          <InputLabel>Mode</InputLabel>
          <Select
            label="Mode"
            value={skipMode}
            onChange={(e)=>setSkipMode(e.target.value)}
          >
            <MenuItem value="byname">By Name</MenuItem>
            <MenuItem value="byaddress">By Address</MenuItem>
            <MenuItem value="bynameaddress">Name + City/State/ZIP</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={8}>
        <TextField
          fullWidth
          size="small"
          label="Name"
          placeholder="Jane Doe"
          value={skipQuery.name}
          onChange={(e)=>setSkipQuery(q=>({ ...q, name: e.target.value }))}
        />
      </Grid>

      {skipMode !== 'byname' && (
        <>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Street"
              placeholder="123 Main St"
              value={skipQuery.street}
              onChange={(e)=>setSkipQuery(q=>({ ...q, street: e.target.value }))}
              disabled={skipMode === 'bynameaddress'}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="City, ST [ZIP]"
              placeholder="Arlington, VA 22203"
              value={skipQuery.citystatezip}
              onChange={(e)=>setSkipQuery(q=>({ ...q, citystatezip: e.target.value }))}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} sx={{ justifyContent:'flex-end' }}>
          <Button onClick={()=>setSkipQuery({ name:'', street:'', citystatezip:'' })}>Clear</Button>
          <Button
            variant="contained"
            onClick={()=>doSkipSearch(1)}
            disabled={skipLoading || (!skipQuery.name && skipMode!=='byaddress')}
          >
            {skipLoading ? 'Searching…' : 'Search'}
          </Button>
        </Stack>
      </Grid>
    </Grid>

    {/* Error */}
    {!!skipError && (
      <Typography color="error" sx={{ mt: 2 }}>{skipError}</Typography>
    )}

    {/* Results */}
{/* Results: visible cards with DMV-first "Most Likely" */}
<Box sx={{ mt: 2 }}>
  {skipLoading && <LinearProgress />}

  {!skipLoading && Array.isArray(skipResults) && skipResults.length > 0 && (() => {
    // IMPORTANT: this 'state' is your UI market picker (e.g., "DMV", "Maryland", etc.)
    const ctx = { market: filterMarket, nameHint: skipQuery.name, cityStateZipHint: skipQuery.citystatezip };
    const scored = scoreSortAndFlag(skipResults, ctx);

    return (
      <Grid container spacing={1.25}>
        {scored.map((r, i) => {
          const id = recId(r) || String(i);
          const name = recName(r) || 'Unknown Name';
          const lives = recLivesIn(r) || 'Location unknown';
          const { state: rState } = parseCityState(lives);
          const inDMV = DMV.has(rState);

          return (
            <Grid item xs={12} sm={6} md={4} key={id}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1,
                  borderRadius: 1.5,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: .75,
                  height: '100%',
                  borderColor: r.__isTop ? (inDMV ? '#10b981' : '#3b82f6') : undefined,
                  boxShadow: r.__isTop ? 2 : 0
                }}
              >
                <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap: .75 }}>
                  <Typography variant="body2" sx={{ fontWeight: 700, pr: .5, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                    {name}
                  </Typography>
                  <Stack direction="row" spacing={0.75} sx={{ flexWrap:'wrap' }}>
                    {r.__isTop && (
                      <Chip
                        size="small"
                        label={inDMV ? 'Most Likely (DMV)' : 'Most Likely'}
                        sx={{ bgcolor: inDMV ? '#bbf7d0' : '#bfdbfe', fontWeight: 700 }}
                      />
                    )}
                    {/* <Chip size="small" label={`Score: ${r.__score}`} sx={{ bgcolor:'#fef3c7' }} /> */}
                    {inDMV && <Chip size="small" label="DMV" sx={{ bgcolor:'#d1fae5', color:'#065f46', fontWeight:700 }} />}
                  </Stack>
                </Box>

                <Typography variant="caption" color="text.secondary">
                  {lives}
                </Typography>

                <Box sx={{ mt: .5, display:'flex', justifyContent:'flex-end', gap: .75 }}>
                  <Button size="small" variant="text" onClick={()=>getDetailsFor(r)}>
                    DETAILS
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={()=>{ setSkipSelected(r); getDetailsFor(r); }}
                  >
                    SELECT
                  </Button>
                </Box>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    );
  })()}

  {!skipLoading && Array.isArray(skipResults) && skipResults.length === 0 && (
    <Typography variant="body2" color="text.secondary">
      No results yet. Enter a query and click Search.
    </Typography>
  )}
</Box>

    {/* Selected details */}
{/* Selected details */}

{!!skipSelected && skipDetail && (
  <Box sx={{ mt: 3 }}>
    <Divider sx={{ mb: 2 }} />
    <Typography variant="subtitle2" sx={{ mb: 1 }}>
      Selected Person
    </Typography>
    <Box sx={{ mt: 1.5, display:'flex', justifyContent:'flex-end', gap: 1 }}>
  <Button
    variant="contained"
    disabled={!selected || !skipDetail}
    onClick={async ()=>{
      try {
        await attachSkipTraceToLead(selected, skipDetail);
        // refresh local selected with a minimal merge so chips/exports see it
        setSelected((prev)=> prev ? ({ ...prev, skipTrace: {
          summary: getSummary(skipDetail),
          phones:  getPhones(skipDetail),
          emails:  getEmails(skipDetail),
          addresses: getAddresses(skipDetail),
          relatives: getRelatives(skipDetail),
        }}) : prev);
      } catch(e) {
        setError(e?.message || String(e));
      }
    }}
  >
    Add skip trace to lead
  </Button>
</Box>
    <Typography variant="body2" sx={{ fontWeight: 700 }}>
      {recName(skipSelected) || '—'}
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      {recLivesIn(skipSelected) || '—'}
    </Typography>

    <Grid container spacing={1.25}>
      {/* Summary */}
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Summary
          </Typography>
          {(() => {
            const sm = getSummary(skipDetail);
            const rows = [
              ['Name', sm.name || '—'],
              ['Age', sm.age || '—'],
              ['DOB', sm.dob || '—'],
            ];
            return (
              <Box
                component="dl"
                sx={{
                  m: 0,
                  display: 'grid',
                  gridTemplateColumns: 'auto 1fr',
                  rowGap: 0.25,
                  columnGap: 1,
                }}
              >
                {rows.map(([k, v]) => (
                  <React.Fragment key={k}>
                    <Typography component="dt" variant="caption" sx={{ color: '#6b7280' }}>
                      {k}
                    </Typography>
                    <Typography component="dd" variant="body2" sx={{ m: 0 }}>
                      {v}
                    </Typography>
                  </React.Fragment>
                ))}
              </Box>
            );
          })()}
        </Paper>
      </Grid>

      {/* Phones */}
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Phones
          </Typography>
          {(() => {
            const phones = getPhones(skipDetail);
            return phones.length ? (
              <Stack spacing={0.5}>
                {phones.map((p, i) => {
                  const masked = phoneMask(p.raw);
                  const meta = [p.type, p.provider, p.last].filter(Boolean).join(' • ');
                  return (
                    <Box
                      key={`${p.raw}-${i}`}
                      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                    >
                      <Box>
                        <Typography variant="body2">{masked || '—'}</Typography>
                        {!!meta && (
                          <Typography variant="caption" color="text.secondary">
                            {meta}
                          </Typography>
                        )}
                      </Box>
                      <Button
  size="small"
  variant="contained"
  onClick={() => openDialer(p.raw)}
>
  Call
</Button>
                    </Box>
                  );
                })}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No phone numbers.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>
<Dialog open={callOpen} onClose={closeDialer} maxWidth="xs" fullWidth>
  <DialogTitle>
    Calling
    <IconButton onClick={closeDialer} sx={{ position: 'absolute', right: 8, top: 8 }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers>
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, letterSpacing: 0.5 }}>
        {callNumber || '—'}
      </Typography>

      <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
        {callStep < 3 ? <LinearProgress sx={{ width: 140 }} /> : null}
        <Chip
          color={callStep === 3 ? 'success' : 'default'}
          label={
            ['Dialing…', 'Ringing…', 'Connecting…', 'Connected'][callStep]
          }
          sx={{ fontWeight: 600 }}
          size="small"
        />
      </Stack>

      {/* step dots */}
      <Stack direction="row" spacing={0.75} sx={{ mt: 1 }}>
        {[0,1,2,3].map(i => (
          <Box
            key={i}
            sx={{
              width: 8, height: 8, borderRadius: '50%',
              bgcolor: i <= callStep ? '#3b82f6' : '#e5e7eb',
              transition: 'background-color .2s'
            }}
          />
        ))}
      </Stack>
      

      
    </Box>
  </DialogContent>

  <DialogActions>
    {callStep < 3 ? (
      <Button onClick={closeDialer} color="error" variant="outlined">Cancel</Button>
    ) : (
      <Button onClick={closeDialer} color="error" variant="contained">Hang Up</Button>
    )}
  </DialogActions>
</Dialog>
      {/* Emails */}
      <Grid item xs={12} md={4}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Emails
          </Typography>
          {(() => {
            const emails = getEmails(skipDetail);
            return emails.length ? (
              <Stack spacing={0.5}>
                {emails.map((addr, i) => (
                  <Box
                    key={`${addr}-${i}`}
                    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                  >
                    <Typography variant="body2">{addr}</Typography>
                    <Button size="small" onClick={() => navigator.clipboard.writeText(addr)}>
                      COPY
                    </Button>
                  </Box>
                ))}
              </Stack>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No emails found.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>

      {/* Address History */}
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Address History
          </Typography>
          {(() => {
            const addrs = getAddresses(skipDetail);
            return addrs.length ? (
              <Grid container spacing={1}>
                {addrs.map((a, i) => {
                  const line = [a.line, [a.city, a.state].filter(Boolean).join(', '), a.zip]
                    .filter(Boolean)
                    .join(' • ');
                  return (
                    <Grid key={`${a.line}-${a.city}-${a.state}-${a.zip}-${i}`} item xs={12} md={6}>
                      <Box sx={{ border: '1px solid #e5e7eb', borderRadius: 1, p: 1 }}>
                        <Typography variant="body2">{line || '—'}</Typography>
                        {a.span && (
                          <Typography variant="caption" color="text.secondary">
                            {a.span}
                          </Typography>
                        )}
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No address history.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>

      {/* Relatives */}
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 1.25 }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#374151' }}>
            Relatives / Associates
          </Typography>
          {(() => {
            const rels = getRelatives(skipDetail);
            return rels.length ? (
              <Grid container spacing={1}>
                {rels.map((r, i) => (
                  <Grid item xs="auto" key={`${r.name}-${i}`}>
                    <Chip size="small" label={`${r.name}${r.relation ? ` • ${r.relation}` : ''}`} />
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography variant="body2" color="text.secondary">
                None listed.
              </Typography>
            );
          })()}
        </Paper>
      </Grid>
    </Grid>
  </Box>
)}



  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseSkipTrace}>Close</Button>
  </DialogActions>
</Dialog>

      {/* Progress Modal */}
      <Dialog open={loading} fullWidth maxWidth="sm">
        <DialogTitle>Working on it…</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Target: {target} lead{target===1?'':'s'}
          </Typography>
          <LinearProgress variant="determinate" value={progress} />
          <Box sx={{ display:'flex', justifyContent:'space-between', mt: 1 }}>
            <Typography variant="body2">{phase}</Typography>
            <Typography variant="body2">{progress}% {eta && `• ${eta}`}</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
